<template>
	<div id="result1" class="overflow-remove contact-page-bg">
		<div v-if="LastAssPageLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<div class="assPDFSection">
			<div id="assessmentPDFHTML" v-if="this.TempFFData && this.TempFFData.length > 0">
				<div class="pdfLogo">
					<img src="../../../public/img/3P_LOGO_Reversed-big.png" />
				</div>
				<div class="scorecardImg">
					<img src="../../../public/img/scorecard.png" />
				</div>
				<div class="assPDFBody">
					<div class="pdftitle">HIRING RECOMMENDATION SCORECARD</div>
					<div class="pdfsubtitle">
						<div><span>Candidate Name:</span><b>{{ this.form.First +' '+ this.form.Last }}</b></div>
						<div><span>Date:</span>{{pdfCDate}}</div>
						<div><span>Licensed:</span>{{ this.form.licensed ? 'Yes' : 'No' }}</div>
						<div><span>Enrolled in Course:</span>{{this.form.prelicensed ? 'Yes' : 'No'}}</div>
					</div>
					<div class="RangeTableContent">
						<table>
							<thead>
								<tr>
									<th scope="col">CAPACITIES</th>
									<th scope="col" colspan="2">Candidate<br>Score</th>
									<th scope="col" colspan="2">
										<u>Desired Range</u>
										<br>Low
									</th>
									<th scope="col" colspan="2">
										<u>Desired Range</u>
										<br>High
									</th>
									<th scope="col" colspan="2">Assessment<br>Rating</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Builder</td>
									<td scope="row" colspan="2">{{ this.TempFFData[0].cciMap.Builder }}</td>
									<td scope="row" colspan="2">{{ LowHighDefaultProfile[0].BuilderLower ?  LowHighDefaultProfile[0].BuilderLower : 0}}</td>
									<td scope="row" colspan="2">{{ LowHighDefaultProfile[0].BuilderUpper ? LowHighDefaultProfile[0].BuilderUpper : 36}}</td>
									<td class="lastChild"><span :style="(rangeWithinTypes(this.TempFFData[0].cciMap.Builder, LowHighDefaultProfile[0].BuilderLower, LowHighDefaultProfile[0].BuilderUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
								</tr>
								<tr>
									<td>Merchant</td>
									<td scope="row" colspan="2">{{this.TempFFData[0].cciMap.Merchant}}</td>
									<td scope="row" colspan="2">{{LowHighDefaultProfile[0].MerchantLower ? LowHighDefaultProfile[0].MerchantLower : 0}}</td>
									<td scope="row" colspan="2">{{LowHighDefaultProfile[0].MerchantUpper ? LowHighDefaultProfile[0].MerchantUpper : 36}}</td>
									<td class="lastChild"><span :style="(rangeWithinTypes( this.TempFFData[0].cciMap.Merchant, LowHighDefaultProfile[0].MerchantLower, LowHighDefaultProfile[0].MerchantUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
								</tr>
								<tr>
									<td>Innovator</td>
									<td scope="row" colspan="2">{{ this.TempFFData[0].cciMap.Innovator}}</td>
									<td scope="row" colspan="2">{{LowHighDefaultProfile[0].InnovatorLower ? LowHighDefaultProfile[0].InnovatorLower : 0}}</td>
									<td scope="row" colspan="2">{{LowHighDefaultProfile[0].InnovatorUpper ? LowHighDefaultProfile[0].InnovatorUpper : 36}}</td>
									<td class="lastChild"><span :style="(rangeWithinTypes( this.TempFFData[0].cciMap.Innovator, LowHighDefaultProfile[0].InnovatorLower, LowHighDefaultProfile[0].InnovatorUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
								</tr>
								<tr>
									<td>Banker</td>
									<td scope="row" colspan="2">{{ this.TempFFData[0].cciMap.Banker}}</td>
									<td scope="row" colspan="2">{{LowHighDefaultProfile[0].BankerLower ? LowHighDefaultProfile[0].BankerLower : 0}}</td>
									<td scope="row" colspan="2">{{LowHighDefaultProfile[0].BankerUpper ? LowHighDefaultProfile[0].BankerUpper : 36}}</td>
									<td class="lastChild"><span :style="(rangeWithinTypes( this.TempFFData[0].cciMap.Banker, LowHighDefaultProfile[0].BankerLower, LowHighDefaultProfile[0].BankerUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
								</tr>
							</tbody>
							<div class="typesTitle">TYPES</div>
							<tbody>
								<tr>
									<td>Community</td>
									<td colspan="2">{{this.TempFFData[0].cciMap.Community}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].CommunityLower ? LowHighDefaultProfile[0].CommunityLower : 0}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].CommunityUpper ? LowHighDefaultProfile[0].CommunityUpper : 72}}</td>
									<td class="lastChild" rowspan="2" colspan="2"><span :style="(rangeWithinTypes(this.TempFFData[0].cciMap.Independent, LowHighDefaultProfile[0].IndependentLower, LowHighDefaultProfile[0].IndependentUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
								</tr>
								<tr class="border-class">
									<td>Independent</td>
									<td colspan="2">{{this.TempFFData[0].cciMap.Independent}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].IndependentLower ? LowHighDefaultProfile[0].IndependentLower : 0}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].IndependentUpper ? LowHighDefaultProfile[0].IndependentUpper : 72}}</td>
								</tr>
								<tr>
									<td>Intuitive</td>
									<td colspan="2">{{this.TempFFData[0].cciMap.Intuitive}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].IntuitiveLower ? LowHighDefaultProfile[0].IntuitiveLower : 0}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].IntuitiveUpper ? LowHighDefaultProfile[0].IntuitiveUpper : 72}}</td>
									<td class="lastChild" rowspan="2" colspan="2"><span :style="(rangeWithinTypes(this.TempFFData[0].cciMap.Cognitive, LowHighDefaultProfile[0].CognitiveLower, LowHighDefaultProfile[0]. CognitiveUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
								</tr>
								<tr class="border-class">
									<td>Cognitive</td>
									<td colspan="2">{{this.TempFFData[0].cciMap.Cognitive}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].CognitiveLower ? LowHighDefaultProfile[0].CognitiveLower : 0}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].CognitiveUpper ? LowHighDefaultProfile[0].CognitiveUpper : 72}}</td>
								</tr>
								<tr>
									<td>Practical</td>
									<td colspan="2">{{this.TempFFData[0].cciMap.Practical}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].PracticalLower ? LowHighDefaultProfile[0].PracticalLower : 0}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].PracticalUpper ? LowHighDefaultProfile[0].PracticalUpper : 72}}</td>
									<td rowspan="2" colspan="2" class="lastChild"><span :style="(rangeWithinTypes(this.TempFFData[0].cciMap.Creative, LowHighDefaultProfile[0].CreativeLower, LowHighDefaultProfile[0].CreativeUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
								</tr>
								<tr>
									<td>Creative</td>
									<td colspan="2">{{this.TempFFData[0].cciMap.Creative}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].CreativeLower ? LowHighDefaultProfile[0].CreativeLower : 0}}</td>
									<td colspan="2">{{LowHighDefaultProfile[0].CreativeUpper ? LowHighDefaultProfile[0].CreativeUpper : 72}}</td>
								</tr>
							</tbody>
						</table>
						<div class="hiringRecommendation">
							<span class="lefttitle">Hiring Recommendation:</span>
							<span v-if="this.TempFFData[0].cciMap.Priority == 1" class="righttitle pr01">Recommended+</span>
							<span v-if="this.TempFFData[0].cciMap.Priority == 2" class="righttitle pr02">Hire with caution</span>
							<span v-if="this.TempFFData[0].cciMap.Priority == 3" class="righttitle pr03">Candidate May Struggle</span>
						</div>
						<div class="ratingKeySection">
							<div class="ratingKey">Rating Key:</div>
							<div class="ratingDiv">
								<span class="color-circle ratingg"></span>
								<span class="ratingTitle">Strong alignment to profile</span>
								<span class="ratingPipe">|</span>
							</div>
							<div class="ratingDiv">
								<span class="color-circle ratingy"></span>
								<span class="ratingTitle">Area of concern</span>
								<span class="ratingPipe">|</span>
							</div>
							<div class="ratingDiv">
								<span class="color-circle ratingr"></span>
								<span class="ratingTitle">Candidate may struggle</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="Object.keys(this.userDocData).length" class="text-left contact-information-stepper w-100 mx-xl-5 px-4">
			<div class="CoreCapSection">
				<img :src='ProfileImageUrl' class="contact-logo"/>
				<span class="CoreCapText">Core Capacitites Index™ Assessment</span>
			</div>
			<h4 class="border-top-before mt-2" :style="{'border-color':HexCode}"></h4>
			<div v-if="activeStep==1" class="step-1-contact border-bottom-solid">
				<h5 class="mt-4 mb-3 pt-3 border-bottom-solid font-weight-bold text-left color-dark-grey"> Contact information</h5> 
				<b-form class="mt-4 contact-form-step1">
					<b-form-group>
						<label class="col-3 col-md-2 px-0 color-dark-grey">First Name:<span class="red">*</span></label>
						<b-form-input
							v-model="form.First"
							placeholder="First"
							required />
					</b-form-group>
					<span v-if="isValid && !form.First" class="red col-10 ml-auto px-0 pb-2 d-block m-top-10">This Field is required</span>
					<b-form-group>
						<label class="col-3 col-md-2 px-0 color-dark-grey">Last Name:<span class="red">*</span></label>
						<b-form-input
							v-model="form.Last"
							placeholder="Last"
							required />
					</b-form-group>
					<span v-if="isValid && !form.Last" class="red col-10 ml-auto px-0 pb-2 d-block m-top-10">This Field is required</span>
					<b-form-group>
						<label class="col-3 col-md-2 px-0 color-dark-grey">Postal Code:<span class="red">*</span></label>
						<b-form-input class="custom-imput-box"
									v-model="form.ZipCode"
									placeholder="Postal Code"
									type="text"
									@keydown="isCheckPostalCode($event)"
									required />
					</b-form-group>
					<span v-if="isValid && !form.ZipCode" class="red col-10 ml-auto px-0 pb-2 d-block m-top-10">This Field is required</span>
					
					<b-form-group >
						<label class="col-3 col-md-2 px-0 color-dark-grey">Phone number:<span class="red">*</span></label>
						<input
							class="custom-phn-no-inputbox w-100"
							type="text"
							placeholder="(xxx) xxx-xxxx"
							v-mask="'(###) ###-####'"
							v-model="form.Number"
							
							@keydown="onNumberKeyDown($event)"
							name="xyz123"
							id="xyz123"
							required />
							
					</b-form-group>
					<span v-if="isValid && !form.Number" class="red col-10 ml-auto px-0 pb-2 d-block m-top-10">This Field is required</span>

					<b-form-group>
						<label name="email" class="col-3 col-md-2 px-0 color-dark-grey">Email Address:<span class="red">*</span></label>
						<b-form-input
							type="email"
							placeholder="Email"
							v-model="form.Email"
							autocomplete="off"
							required />
					</b-form-group>

					<b-form-group>
						<label class="col-5 col-md-5 px-0 color-dark-grey">Do you currently hold an active real estate license?<span class="red">*</span></label>
						<span class="licensespan1">
							<input type="radio" name="licensed" v-bind:value="true" v-model="form.licensed" @change="radioLicensed()" required>
							<span class="licensespan2"> Yes</span>
						</span> 
						<span class="licensespan1">
							<input type="radio" name="licensed" v-bind:value="false" v-model="form.licensed" @change="radioLicensed()" required>
							<span class="licensespan2">No</span>
						</span> 
					</b-form-group>

					<b-form-group v-if="prelicensedOption">
						<label class="col-5 col-md-5 px-0 color-dark-grey">Are you currently enrolled in a real estate pre-licensing course?<span class="red">*</span></label>
						<span class="licensespan1">
							<input type="radio" name="prelicensed" v-bind:value="true" v-model="form.prelicensed">
							<span class="licensespan2"> Yes</span>
						</span> 
						<span class="licensespan1">
							<input type="radio" name="prelicensed" v-bind:value="false" v-model="form.prelicensed">
							<span class="licensespan2">No</span>
						</span> 
					</b-form-group>

					<span v-if="isValid && !form.Email" class="red col-10 ml-auto px-0 pb-2 d-block m-top-10">This Field is required</span>
					<!-- <span class="w-100 text-center d-inline-block"> *your evaluation results will be sent to this address </span> -->
				</b-form>
				
			</div>
			
			<div v-if="activeStep==2" class="step-2-contect border-bottom-solid">
				<h5 class="mt-4 mb-3 border-bottom-solid font-weight-bold text-left color-dark-grey"> Is working as a Real Estate Professional a Good Fit for You?</h5>
				<p class="text-left color-dark-grey">In one sense, considering a new job is hopeful and exciting, but it often causes some fear and concern.</p>
				<p class="text-left color-dark-grey">Am I going to perform well in this role? Am I going to enjoy the day-to-day tasks required in this position? Are my unique strengths and talents aligned with this type of work?</p> 
				<p class="text-left color-dark-grey">You’re not alone. These are the questions we all ask ourselves when making a change.</p> 
				<p class="text-left color-dark-grey">The assessment on the next page (called the Core Capacities Index) is one of the best tools available to help you discover the answers to these important questions.</p>
				<p class="text-left color-dark-grey">This assessment takes just a few minutes to complete and has been independently validated to be more than 90% reliable. It’s helped thousands of individuals like you make better career decisions, pursue work they find engaging, and flourish in their day-to-day employment.</p>
				<p class="text-left color-dark-grey">Press the “Continue” button to get started:</p>
			</div>

			<div v-if="activeStep==3 || activeStep==4 || activeStep==5" class="step-3-contact border-bottom-solid">
				<h5 class="mt-4 mb-3 border-bottom-solid font-weight-bold text-left color-dark-grey"> Core Capacities Index</h5>
				<div class="capacity-content text-left ml-2 mr-2">
					<p class="mb-1 color-dark-grey">1. <span>Check the two words in each box that most relate to you -- the words that have the greatest value to you.</span></p>
					<p class="mb-1 color-dark-grey">2. <span>Don't spend more than 5 seconds per box.</span></p>
					<p class="mb-1 color-dark-grey">3. <span>Mouse over the ? button if you are unsure of a word definition.</span></p>
					<p class="mb-1 color-dark-grey">4. <span>Complete all boxes.</span></p>
				</div>
				<!-- Daynmic Checkbox Code started -->
				<div v-for="(item, index) in cciMap" :key="index" >
					<div v-if="(activeStep == 3 && index == 0) || (activeStep == 4 && index == 1) || (activeStep == 5 && index == 2)" class="border-all">
						<div v-for="(item1, index1) in cciMap[index]" :key="index1"  class="d-flex flex-wrap w-100 custom-box-4">
							<div v-for="(item2, index2) in cciMap[index][index1]" :key="index2"  class="text-left border-all four-box">
								<div class=" form-group-for-checkbox mb-0" v-for="(item3, index3) in cciMap[index][index1][index2]" :key="index3">
									<!-- <b-form-checkbox 
										class="custom-checkbox-fill p-0"
										v-model="item3.isBoxSelected"
										@change="changeCheckBoxEvent($event,item3,index,index1,index2,index3)" 
										name="check-default"
										>
										{{item3.CVI_Word}}
										<v-icon name="question" v-b-tooltip.hover :title="item3.CVI_Word_Definition" class="contact-list-info"></v-icon>
									</b-form-checkbox> -->
									<input type="checkbox" :id="item3.CVI_Word_ID" class="custom-checkbox-fill p-0" v-model="item3.isBoxSelected" @click="changeCheckBoxEvent($event,item3,index,index1,index2)">
									<label :for="item3.CVI_Word_ID" class="checkbox-label ml-1 mr-1 color-dark-grey">{{item3.CVI_Word}}<v-icon name="question" v-b-tooltip.hover :title="item3.CVI_Word_Tooltip" class="contact-list-info ml-1"></v-icon></label>
									
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Daynmic Checkbox Code End --> 
				<b-button-group class="w-100 submit-form-btn btn-group d-inline-block text-right mt-4 mb-2">
					<b-button variant="outline-primary mr-3"  @click="resetPageData" v-if="processingLastSpanOpp">Reset Page</b-button>
					<b-button variant="outline-primary"  @click="saveAssessment" v-if="processingLastSpanOpp">Continue</b-button>
					<span class="processingLastSpan" v-if="processingLastSpan">Processing ...</span>
				</b-button-group>
			</div>

			<!-- <div v-if="activeStep == 6">
				<div v-for="(item, index) in cciMap" :key="index" >
					<div v-for="(item1, index1) in cciMap[index]" :key="index1"  >
						<div v-for="(item2, index2) in cciMap[index][index1]" :key="index2"  class="text-left ">
							<div v-for="(item3, index3) in cciMap[index][index1][index2]" :key="index3">
								<p v-if="item3.isBoxSelected">{{item3.CVI_Word_Definition}}</p>
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<div v-if="activeStep == 7" class="step-2-contect border-bottom-solid">
				<!-- <h1> You have already submited response </h1> -->
				<h5 class="mt-4 mb-3 border-bottom-solid font-weight-bold text-left color-dark-grey"> Thank You for Your Interest in the Core Capacities Index
					<!-- <sup> TM</sup>  -->
				Assessment</h5>
				<p class="text-left color-dark-grey">We've received your application. Our records indicate that you previously applied and already completed the CCI assessment.</p>
				<p class="text-left color-dark-grey">We updated your contact information and let our recruiting team know of your interest in this position. One of our recruiters will be in contact with you soon.</p>
			</div>

			<!-- <div v-if="activeStep == 8" class="step-2-contect border-bottom-solid">
				<h5 class="mt-4 mb-3 border-bottom-solid font-weight-bold text-left"> Thank You</h5>
				<p class="text-left">We appreciate you taking the time to explore your career options with our company.</p>
				<p class="text-left">If you elected to receive your assessment results by email, you should receive them immediately. If you do not receive a results email within the next 15 minutes, please check your "junk email" folder.</p>
				<p>Please close your browser now to log out.</p>
			</div> -->
			
			<!-- v-if="activeStep == 6" -->
			<div v-if="activeStep == 6" id="resultDiv"  ref="step6Ref" class="step-2-contect border-bottom-solid">
				<div id="result2">
				<h5 class="mt-4 mb-3 border-bottom-solid font-weight-bold text-left color-dark-grey"> Thank You for Completing the Core Capacities Index
					<!-- <sup> TM</sup>  -->
				Assessment</h5>
					<p class="text-left color-dark-grey">Thank you for taking the Core Capacities Index 
						<!-- <sup> TM</sup>  -->
						(CCI). The CCI is based on a validated and proprietary
						assessment protocol that paints an accurate picture of a person’s core capacities. Core capacities are
						the unique 'recipe' of organic talents that make up each of us.
					</p>
					<p class="text-left color-dark-grey">Conventional personality or behavioral assessments attempt to capture a person’s behavioral patterns or
						surface traits. A person’s surface traits will vary greatly depending on age, environment, interests, and
						other factors. Core capacities are different. They tend to be stable, unchanging factors that reside below a
						person’s surface traits.
					</p>
					<p class="text-left color-dark-grey">It is important for you to understand your core capacities if you want to flourish in the day-to-day work that
						you do. New research has demonstrated a strong connection between a person’s unique recipe of core
						capacities and the tasks they perform on the job. If a person’s core capacities are aligned with the tasks
						they are performing, there is a high propensity for vital engagement and top performance.
					</p>
					<h5 class="mt-4 mb-3 font-weight-bold text-left color-dark-grey">Your Personal Core Capacities Index
						<!-- <sup> TM</sup>  -->
						Results</h5>
					<p class="text-left color-dark-grey">The CCI scoring system is based upon a scale in each quadrant that ranges from 0 to 36. The score in
						each quadrant indicates a relative strength of that core capacity compared to the other quadrants.
						Generally, a person is strongly inclined toward one core capacity strategy with a second core capacity
						strategy also being a very important part of their make-up. But, the balance of the scores is very important
						and has a compelling effect on how you will engage tasks in your day-to-day work. Your CCI scores are:
					</p>
					<!-- class="contact-infor-table w-100" -->
					<table  style="border: 1px solid #000;width: 100% !important;">
						<thead>
							<th class="color-dark-grey" style="border: 1px solid #000;text-align: center;" v-for="(item, index) in resultArray" :key="index">{{item.key}}</th>
						</thead>
						<tbody>
							<tr>
								<td class="color-dark-grey" style="border: 1px solid #000;text-align: center;" v-for="(item, index) in resultArray" :key="index"><b>{{item.value}}</b></td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div id="result3" class="d-flex align-items-center w-100">
					<b-form-group class="contact-last-form mt-3 mb-3 align-items-center w-100">
							<p class="text-left mb-2 f-14 w-100"><b>Email My Results</b></p>
							<b-form-input label="abc" type="email" placeholder="Email" 
							class="col-6 contact-last-input form-control mr-2"  v-model="sendMailAddress" />
							<b-button variant="outline-primary" @click="sendEmail">Send</b-button>
					</b-form-group>
				</div> -->
				<div id="result4">
					<h5 class="mt-4 mb-3 font-weight-bold text-left color-dark-grey">Your Personal Core Capacities Index
						<!-- <sup> TM</sup>  -->
						Snapshot</h5>
					<p class="text-left color-dark-grey">
						<b>Your unique dominant {{sortedResultArray[0].key}} Capacity Set causes you to rely on the following strategies for success and fulfillment:</b>
					</p>
					<p class="color-dark-grey" v-html="sortedResultArray[0].def"></p>
					<!-- <p class="color-dark-grey" v-for="(item, index) in sortedResultArray[0].defArray" :key="index">
						<span v-for="(item1, index1) in sortedResultArray[0].defArray[index]" :key="index1">{{item1}}</span>
					</p> -->
					<p class="color-dark-grey">
						<b>Your unique secondary {{sortedResultArray[1].key}} Capacity Set supports your dominant  {{sortedResultArray[0].key}} Capacity Set.</b>
					</p>
					<p class="color-dark-grey" v-html="sortedResultArray[1].def">  </p>
					<!-- <p v-for="(item2, index2) in sortedResultArray[1].defArray" :key="index2">
						<span v-for="(item3, index3) in sortedResultArray[1].defArray[index2]" :key="index3">{{item3}}</span>
					</p> -->
					<p class="color-dark-grey">
						<b>Your third level {{sortedResultArray[2].key}} Capacity Set gives you the ability to respond appropriately to a broad spectrum of situations.</b>
					</p>
					<p class="color-dark-grey" v-html="sortedResultArray[2].def"></p>
					<!-- <p v-for="(item, index) in sortedResultArray[2].defArray" :key="index">
						<span v-for="(item1, index1) in sortedResultArray[2].defArray[index]" :key="index1">{{item1.key}}</span>
					</p> -->
					<p class="color-dark-grey">
						<b>Your fourth level {{sortedResultArray[3].key}} Capacity Set gives you the opportunity to live a balanced and successful life.</b>
					</p>
					<p class="color-dark-grey" v-html="sortedResultArray[3].def"></p>
					<!-- <p v-for="(item, index) in sortedResultArray[3].defArray" :key="index">
						<span v-for="(item1, index1) in sortedResultArray[3].defArray[index]" :key="index1">{{item1.key}}</span>
					</p> -->

					<h5 class="mt-4 mb-3 font-weight-bold text-left color-dark-grey">Will You Flourish in Our Company?</h5>
						<p class="color-dark-grey">We would like to thank you for taking the time to complete the Core Capacities Index
							<!-- <sup> TM</sup>  -->
							evaluation. The
							CCI has helped thousands of people clarify their direction and create better alignment between their
							unique core capacities and their work.
						</p>
						<p class="mb-3 color-dark-grey">Your confidential results will now be sent to one of our hiring managers for evaluation. With the assistance
							of a proprietary pattern matching algorithm, the hiring manager will build a correlation between your
							personal CCI scores and those typical of high performers working in this role.
					</p>
					<p class="color-dark-grey">If you have any questions concerning this issue, you may contact our recruiting coordinator:</p>
					<p class="color-dark-grey">{{userDocData.Company}}
					<br>{{userDocData.First}} {{userDocData.Last}}
					<br>{{userDocData.Title}}
					<br>{{this.$parseNumber(userDocData.Twilio)}}
					<br>{{userDocData.SendGrid}}</p>
					<p class="color-dark-grey">Thanks again for taking the time to complete the Core Capacities Index 
						<!-- <sup> TM</sup>  -->
						evaluation and we wish you the
						best success in your career.
					</p>
				</div>
				<div id="result3" class="d-flex align-items-center w-100">
					<b-form-group class="contact-last-form mt-3 mb-3 align-items-center w-100">
							<!-- <p class="text-left mb-2 f-14 w-100 color-dark-grey"><b>Email My Results</b></p> -->
							<!-- <b-form-input label="abc" type="email" placeholder="Email"  -->
							<!-- class="col-6 contact-last-input form-control mr-2"  v-model="sendMailAddress" /> -->
							<!-- <b-button variant="outline-primary" @click="sendEmail">Send</b-button> -->
							<!-- <b-button variant="outline-primary" @click="MailSend">Send</b-button> -->
							
							<b-button class="ml-2" variant="outline-primary" @click="printEmail">Print</b-button>
					</b-form-group>
				</div>
			</div>
			<b-button-group v-if="activeStep == 1 || activeStep == 2" class="px-3 w-100 submit-form-btn btn-group d-inline-block text-center mt-4 mb-2">
				<b-button variant="outline-primary" @click="saveAssessment">Continue</b-button>
			</b-button-group>
			<div class="copyright-sc mt-3 color-dark-grey">
				&copy; 2024 ThirdPool Recruiting.  All Rights Reserved.   Powered by Taylor Protocols.
			</div>
		</div>
		<div id="assessmentMulEmailEmpty"></div>
		<div id="assessmentMulEmail" style="display:none;" v-if="(this.authUser && Object.keys(this.authUser).length) && (this.TempFFData && this.TempFFData.length > 0)">
			<div>
				<p style="font-weight:600;color:#000;">Hello,</p>
				<p style="font-weight:600;color:#000;">Here are the CCI Assessment Results for {{this.form.First}} {{this.form.Last}}.</p>
				<p style="margin-bottom:0"><b>CONTACT INFORMATION:</b></p>
				<p style="margin-bottom:0"><b>Name: </b>{{this.form.First}} {{this.form.Last}}</p>
				<p style="margin-bottom:0"><b>Email: </b>{{this.form.Email}}</p>
				<p style="margin-bottom:0"><b>Phone Number: </b>{{this.form.Number}}</p>
				<p style="margin-bottom: 1rem;"><b>Postal Code: </b>{{this.form.ZipCode}} </p>
				<p><b>CCI Scores</b></p>
				<p style="margin-bottom: 1rem;" v-if="this.TempFFData[0].cciMap.hasOwnProperty('Scorecard')"><a style="color:#007bff;" target="blank" :href="this.TempFFData[0].cciMap.Scorecard">Hiring Scorecard</a></p>
				<p style="margin-bottom:1rem;"><b>Priority Score: </b> {{this.TempFFData[0].cciMap.Priority}}</p>
				<p style="margin-bottom: 1rem;"> <b>Licensed?:</b> {{this.form.licensed===true ? 'Yes' : 'No'}}</p>
				<p style="margin-bottom: 1rem;"> <b>Enrolled in Course?:</b> {{this.form.prelicensed===true ? 'Yes' : 'No'}}</p>
				<!-- <p style="margin-bottom:1rem;"><img :src="this.AssessmentResultsImg" width="100%" /></p>         -->
				<p> 
					<b> {{this.TempFFData[0].cciMap.SnapshotName}} Summary </b> <a target="blank" :href="snapshotDetails.Url" style="color:#007bff;cursor: pointer"><i>{{this.TempFFData[0].cciMap.SnapshotName}} Profile</i> </a> 
				</p>
				<p>
					<span v-html="this.snapshotDetails.Summary"></span>
				</p>
				<p> 
					<b> {{this.TempFFData[0].cciMap.SnapshotName}} Interview Questions </b>
					<span v-html="this.snapshotDetails.Questions"></span>
				</p> 

				<p style="margin-bottom:5px">Learn more about <a href="https://thirdpool.com/assessment/CoreValues.html" target="_blank" style="color:#007bff;cursor: pointer">Core Capacities and Personality Types </a></p><p>Read ThirdPool's <a target="_blank" href=" https://thirdpool.com/assessment/Interviewing-Primer.pdf" style="color:#007bff;cursor: pointer">"Preparing for an Interview"</a> primer on conducting a successful interview. </p>

				<p style="margin-bottom:0">{{this.user.First}} {{this.user.Last}}</p>
				<p style="margin-bottom:0">{{this.user.Title}}</p>
				<p style="margin-bottom:0">{{this.$parseNumber(this.user.Twilio)}}</p>
				<p>{{this.user.SendGrid}} </p>
			</div>
		</div> 
	</div>

</template>

<script>
	import { mapState } from 'vuex'
	import axios from "axios";
	import moment from 'moment';
	import { getAppSettings, auth } from 'src/db'
	export default {
		name: "AssessmentUser",
		// computed: {
        // 	...mapState('firebase', ['user'])
		// },
		computed: {
            ...mapState('firebase', ['prospects', 'user'])
	},
		methods: {
			// RANGE TABLE
			rangeWithinTypes(value, minValue, maxValue, yellowColorLogic, redColorLogic) {
				var colorCode;
				if (value >= minValue && value <= maxValue) {
					colorCode = 'background-color: #2fca2f'; // GREEN
				} else if ((value >= minValue - yellowColorLogic && value <= minValue) || (value >= maxValue && value <= maxValue + yellowColorLogic)) {
					colorCode = 'background-color: #dcdc09'; // YELLOW
				} else if ((value >= minValue - redColorLogic && value <= minValue) || (value >= maxValue && value <= maxValue + redColorLogic)) {
					colorCode = 'background-color: #fd4c4c'; // RED
				} else {
					colorCode = 'background-color: #fd4c4c'; // RED
				}
				return colorCode;
			},
			async oldassessmentPDFProcess() {
				try {
					const el = document.getElementById("assessmentPDFHTML");
					const options = {
						type: "dataURL",
						useCORS: false,
						imageSmoothingEnabled: false
					};
					if (el) {
						var html2canvasDiv = await this.$html2canvas(el,options);
						//eslint-disable-next-line
						console.log('DATA:', html2canvasDiv);
						let passData = {
							localArray:  html2canvasDiv,
						};
						await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/assessmentUploadPDF", passData)
						.then(response => {
							//eslint-disable-next-line
							console.log('assessmentUploadPDF:', response);
							
							var newff = this.TempFFData[0]; // GET FF DATA
							newff.cciMap['Scorecard'] = response.data.surl;
							this.updateProspFromAssessmentFn(newff);
							
						})
					} else {
						//eslint-disable-next-line
						console.log('Element not found in the document.');
					}
				} catch (error) {
					//eslint-disable-next-line
					console.error('Error finding HTML element:', error);
				}
			},
			// ASSESSMENT PDF PROCESS
			async assessmentPDFProcess2407() {
				try {
					const el = document.getElementById("assessmentPDFHTML");
					const options = {
						type: "dataURL",
						useCORS: true,
						imageSmoothingEnabled: false,
						allowTaint: true
					};
					if (el) {
						const originalViewport = document.querySelector('meta[name="viewport"]').getAttribute('content');

						// Set the viewport meta tag to simulate a desktop view
						document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=1200');

						const canvas = document.createElement("canvas");
						const ctx = canvas.getContext("2d");

						// const desiredWidth = 1200; // Desired width for desktop view

						const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
						const desiredWidth = Math.min(screenWidth, 1200);

						const scaleFactor = desiredWidth / el.offsetWidth;
						const canvasWidth = desiredWidth;
						const canvasHeight = el.offsetHeight * scaleFactor;

						canvas.width = canvasWidth;
						canvas.height = canvasHeight;

						await this.$html2canvas(el, {
							...options,
							canvas: canvas,
							canvasContext: ctx,
							scale: scaleFactor
						}).then(() => {
							if (canvas instanceof HTMLCanvasElement) {
								document.querySelector('meta[name="viewport"]').setAttribute('content', originalViewport);

								const dataURL = canvas.toDataURL();
								let passData = {
									localArray: dataURL,
								};
								return axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/assessmentUploadPDF", passData)
								.then(response => {
									//eslint-disable-next-line
									console.log('assessmentUploadPDF:', response);
									
									var newff = this.TempFFData[0]; // GET FF DATA
									newff.cciMap['Scorecard'] = response.data.surl;
									this.updateProspFromAssessmentFn(newff);
									
								})
							} else {
								throw new Error("The canvas object is not a valid HTMLCanvasElement.");
							}
						})
					}
				} catch (error) {
					//eslint-disable-next-line
					console.error("Error finding HTML element:", error);
				}
			},
			async assessmentPDFProcess() {
				try {
					const el = document.getElementById("assessmentPDFHTML");
					const options = {
						type: "dataURL",
						useCORS: false,
						imageSmoothingEnabled: false,
					};

					if (el) {
						// Apply CSS to adjust the layout to match desktop view size
						el.style.width = "1200px"; // Set the desired width for the desktop view

						await new Promise(resolve => setTimeout(resolve, 1000));

						const canvas = document.createElement("canvas");
						const ctx = canvas.getContext("2d");
						const canvasWidth = 1200; // Set the desired width for the canvas
						const scaleFactor = canvasWidth / el.offsetWidth;
						const canvasHeight = el.offsetHeight * scaleFactor;

						canvas.width = canvasWidth;
						canvas.height = canvasHeight;

						// Scale and draw the captured content onto the adjusted canvas
						await this.$html2canvas(el, {
							...options,
							canvas: canvas,
							canvasContext: ctx,
							scale: scaleFactor
						}).then(() => {
							if (canvas instanceof HTMLCanvasElement) {
								const dataURL = canvas.toDataURL();
								let passData = {
									localArray: dataURL,
								};
								axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/assessmentUploadPDF", passData).then(response => {
										//eslint-disable-next-line
										console.log('assessmentUploadPDF:', response);
										
										var newff = this.TempFFData[0]; // GET FF DATA
										newff.cciMap['Scorecard'] = response.data.surl;
										this.updateProspFromAssessmentFn(newff);		
								})
							} else {
								throw new Error("The canvas object is not a valid HTMLCanvasElement.");
							}
						});

						// Reset the CSS changes after capturing the content
						el.style.width = ""; // Remove the width adjustment
					}
				} catch (error) {
					//eslint-disable-next-line
					console.error("Error finding HTML element:", error);
				}
			},
			// UPDATE PROSPECT ASSESSMENT
			async updateProspFromAssessmentFn(ff) {
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/updateProspFromAssessment", ff)
				.then(response => {
					//eslint-disable-next-line
					console.log("updateProspFromAssessmentFn:", response);
				}).catch(err => {alert(`Failure in Updating prospect from assessment: ${err}`); return;});
			},
			radioLicensed() {
				if(this.form.licensed == false) {
					this.prelicensedOption = true;
				} else {
					this.prelicensedOption = false;
				}
				this.form.prelicensed = '';
			},
			onNumberChange() {
				if (this.form.Number && this.$parseNumber(this.form.Number).length < 12) {
					alert("Phone Number is not valid");
					return
				}
				this.convertedNo = this.$parseNumber(this.form.Number);	
			},
			onNumberKeyDown(event) {
				if (this.$parseNumber(this.form.Number).length < 3) {
					if (event.key == '0' || event.key == '1') {
						event.preventDefault();
					}
				}
			},
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			zipCodeOnKeyDown(event) {
				if (this.form.ZipCode.length >= 5) {
					if (event.key == '0' || event.key == '1' || 
						event.key == '2' || event.key == '3' || 
						event.key == '4' || event.key == '5' || 
						event.key == '6' || event.key == '7' ||
						event.key == '8' || event.key == '9') 
					{
						event.preventDefault();
					}
				}
			},
			printEmail() {
				window.print()
			},
			// MailSend()
			// {
			// 	for (let e of this.prospects) {
			// 		if(e.CciMap) {
			// 			this.sendEmail(e.Email);
			// 			//eslint-disable-next-line
			// 			console.log('Mail successfully sent:', e.Email);
			// 		}
			// 	}
			// },
			async sendEmail() {
				// await this.getProspectDetailsByEmail(this.sendMailAddress);
				await this.getProspectDetailsByEmail(this.form.Email);
				let isProspect = false;
				let sendEmailProspID = '';
				if (this.emailProspData.length) {
					isProspect = true;
					sendEmailProspID = this.emailProspData[0].id
				}
				let removeHtml = document.getElementById("result3").innerHTML;
				let divHtml = document.getElementById("resultDiv").innerHTML;
				divHtml = divHtml.replace(removeHtml,'');
				const smsData = {
					// toEmail:this.sendMailAddress,
					toEmail:this.form.Email,
					fromEmail:this.userDocData.SendGrid,
					fromName:this.userDocData.First + ' '+ this.userDocData.Last,
					subject:'Assessment Result',
					body:divHtml,
					isProspect:isProspect,
					ProspectID:sendEmailProspID,
					Uid:this.userDocData.Uid
				};
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendResultEmail", smsData)
				.then(response => {
					//eslint-disable-next-line
					console.log(response);
					/*setTimeout(() => {
						if (isProspect) {
							this.$bvToast.toast('Email is sent successfully!', {
								title: `Success`,
								variant: 'success',
								solid: true
							});
						}else {
							this.$bvToast.toast('Email is sent successfully!, but prospect did not record because same email does not exist', {
								title: `Success`,
								variant: 'success',
								solid: true
							});
						}
					}, 500);
					*/
				}).catch(err => 
					this.$bvToast.toast(`Failure Sending Email: ${err}`, {
						title: `Error`,
						variant: 'danger',
						solid: true
				})
				);
			},
			// SEND EMAILS AFTER ASSESSMENT FORM COMPLETE
			async sendEmailAfterAssessmentForm(){
				await this.getProspectDetailsByEmail(this.form.Email);
				let isProspect = false;
				let sendEmailProspID = '';
				var tempArray = [];
				// if (this.emailProspData.length) {
				// 	isProspect = true;
				// 	sendEmailProspID = this.emailProspData[0].id
				// }
				this.user.CciProfiles.map(e=>{
					if(e.Default === true){
						tempArray=e.Emails
					}
				});
				await getAppSettings({
					sid:'1izpGSmYBlUGDSdKIRxa'
				})
				.then((res) => {
					let spa = res.data.Snapshots;
					let f =  spa.find(p => p.Name == this.TempFFData[0].cciMap.SnapshotName);
					if (f) {
						this.snapshotDetails = f;
					}
				})
				.catch(err => alert(`Failure In Getting AppSettings : ${err}`));
				let removeHtml = document.getElementById("assessmentMulEmailEmpty").innerHTML;
				let divHtml = document.getElementById("assessmentMulEmail").innerHTML;
				divHtml = divHtml.replace(removeHtml, '');
				const emailBody = {
					toEmail: tempArray ? tempArray.flat(1) : '',
					fromEmail: this.userDocData.SendGrid,
					fromName: this.userDocData.First + ' ' + this.userDocData.Last,
					subject: 'Assessment Result',
					body: divHtml,
					isProspect: isProspect,
					ProspectID: sendEmailProspID,
					Uid: this.userDocData.Uid
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendResultEmail", emailBody)
				.then(response => {
					//eslint-disable-next-line
					console.log('test emails send',response);
					this.LastAssPageLoader=false;
				}).catch(err =>
					this.$bvToast.toast(`Failure Sending Email: ${err}`, {
						title: `Error`,
						variant: 'danger',
						solid: true
					})
				) 
			},
			async ProspDataWhileAssessmentUserInZapier() {
				if (!this.authUser || this.prospects.find(prosp => prosp.Number != this.convertedNo)) {
					await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/ProspDataWhileAssessmentUserInZapier", {
						pid: this.userDocId,
						ph:this.convertedNo
					})
					.then(response => {
						//eslint-disable-next-line
						console.log('response: ',response)
					}).catch(err => {alert(`Failure in creatin prospect from assessment user: ${err}`); return;});
				}
			},
			async saveAssessment() {
				// let selectedWordsArray = [];
				if (this.activeStep == 1) {
					if (this.form.First && this.form.Last && this.form.ZipCode && this.form.Number && this.form.Email && (this.form.licensed === false || this.form.licensed === true)) {
						if((this.form.licensed === false) && (this.form.prelicensed === '')) {
							this.isValid = true;
							return
						} else {
						if (this.form.Number && this.$parseNumber(this.form.Number).length < 12) {
							alert("Phone Number is not valid");
							return
						}
						this.convertedNo = this.$parseNumber(this.form.Number);
						await this.getProspectDetailsByPhoneNumber(this.convertedNo);
						if (this.prospData.length) { // prospect found check for CCIMAP already responed or new responses
							if (this.prospData[0].hasOwnProperty("CciMap") && Object.keys(this.prospData[0].CciMap).length) {
								this.activeStep = 7;
								return;
							}
						}else { // create new prospect based on contact form value 
							this.convertedNo = this.$parseNumber(this.form.Number);	
							this.form.Number = this.convertedNo;
							this.form.pid =  this.userDocId;
							// this.form.Notes[Date.now()] = 'Prospect Applied from the CCI';
							await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createProspFromAssessment", this.form)
							.then(response => {
								//eslint-disable-next-line
								console.log(response)
							}).catch(err => {alert(`Failure in creatin prospect from assessment: ${err}`); return;});
							this.ProspDataWhileAssessmentUserInZapier();
						}
						}
					}else {
						this.isValid = true;
						return
					}
				}
				else if (this.activeStep == 3 || this.activeStep == 4 || this.activeStep == 5) {
					let currentIndex = this.activeStep - 3;
					let isValid = true;
					for (let j = 0;j<this.cciMap[currentIndex].length;j++) {
						for (let k = 0; k<this.cciMap[currentIndex][j].length; k++) {
							let validateArray = this.cciMap[currentIndex][j][k].filter(a=>a.isBoxSelected);
							if (validateArray.length !== 2) {
								isValid = false;
								break;
							}
						}
						if (!isValid) {
							break;
						}
					}
					if (!isValid) {
						alert('Please select two words in each box');
						return;
					}
					if (this.activeStep == 3 || this.activeStep == 4 || this.activeStep == 5) {
						for (let j = 0;j<this.cciMap[currentIndex].length;j++) {
							for (let k = 0; k<this.cciMap[currentIndex][j].length; k++) {
								for (let l = 0; l<this.cciMap[currentIndex][j][k].length; l++) {
									if (this.cciMap[currentIndex][j][k][l].isBoxSelected) {
										if (this.cciMap[currentIndex][j][k][l].CVI_Word_Score == 'A') {
											this.builderCount = this.builderCount + 1;

											if (this.builderCount == 11) {
												this.builderDefinition = this.builderDefinition + ' <p class="mt-2"> ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.builderCount == 22) {
												this.builderDefinition = this.builderDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.builderCount == 33) {
												this.builderDefinition = this.builderDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else {
												this.builderDefinition = this.builderDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}
											
											// this.builderDefinitionArray.push({key:this.cciMap[currentIndex][j][k][l].CVI_Word_Definition});
											this.builderDefinitionArray.push(this.cciMap[currentIndex][j][k][l].CVI_Word_Definition);
										}else if (this.cciMap[currentIndex][j][k][l].CVI_Word_Score == 'B') {
											this.merchantCount = this.merchantCount + 1;

											if (this.merchantCount == 11) {
												this.merchantDefinition = this.merchantDefinition + ' <p class="mt-2"> ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.merchantCount == 22) {
												this.merchantDefinition = this.merchantDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.merchantCount == 33) {
												this.merchantDefinition = this.merchantDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else {
												this.merchantDefinition = this.merchantDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}

											// this.merchantDefinition = this.merchantDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											// this.merchantDefinitionArray.push({key:this.cciMap[currentIndex][j][k][l].CVI_Word_Definition});
											this.merchantDefinitionArray.push(this.cciMap[currentIndex][j][k][l].CVI_Word_Definition);
										}else if (this.cciMap[currentIndex][j][k][l].CVI_Word_Score == 'C') {
											this.innovatorCount = this.innovatorCount + 1;

											if (this.innovatorCount == 11) {
												this.innovatorDefinition = this.innovatorDefinition + ' <p class="mt-2"> ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.innovatorCount == 22) {
												this.innovatorDefinition = this.innovatorDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.innovatorCount == 33) {
												this.innovatorDefinition = this.innovatorDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else {
												this.innovatorDefinition = this.innovatorDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}

											// this.innovatorDefinition = this.innovatorDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											// this.innovatorDefinitionArray.push({key:this.cciMap[currentIndex][j][k][l].CVI_Word_Definition});
											this.innovatorDefinitionArray.push(this.cciMap[currentIndex][j][k][l].CVI_Word_Definition);
										}else if (this.cciMap[currentIndex][j][k][l].CVI_Word_Score == 'D') {
											this.bankerCount = this.bankerCount + 1;

											if (this.bankerCount == 11) {
												this.bankerDefinition = this.bankerDefinition + ' <p class="mt-2"> ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.bankerCount == 22) {
												this.bankerDefinition = this.bankerDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else if (this.bankerCount == 33) {
												this.bankerDefinition = this.bankerDefinition + ' </p> <p class="mt-2">' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}else {
												this.bankerDefinition = this.bankerDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											}

											// this.bankerDefinition = this.bankerDefinition + ' ' + this.cciMap[currentIndex][j][k][l].CVI_Word_Definition;
											// this.bankerDefinitionArray.push({key:this.cciMap[currentIndex][j][k][l].CVI_Word_Definition})
											this.bankerDefinitionArray.push(this.cciMap[currentIndex][j][k][l].CVI_Word_Definition)
										}
										this.selectedWordsArray.push(this.cciMap[currentIndex][j][k][l]);
									}
								}
							}
						}
						if (this.activeStep == 5) {
							let bd = [];
							let md = [];
							let ida = [];
							let bda = [];
							if (this.builderCount > 10) {
								this.builderDefinition = this.builderDefinition + '</p>';
								if (this.builderCount > 10 && this.builderCount < 21) {
									let b1 = this.builderDefinitionArray.slice(0,10);
									let b2 = this.builderDefinitionArray.slice(11,this.builderCount);
									bd.push(b1,b2);
								}else if (this.builderCount > 20 && this.builderCount < 31) {
									let b1 = this.builderDefinitionArray.slice(0,10);
									let b2 = this.builderDefinitionArray.slice(11,20);
									let b3 = this.builderDefinitionArray.slice(20,this.builderCount);
									bd.push(b1,b2,b3);
								}else {
									let b1 = this.builderDefinitionArray.slice(0,10);
									let b2 = this.builderDefinitionArray.slice(11,20);
									let b3 = this.builderDefinitionArray.slice(21,30);
									let b4 = this.builderDefinitionArray.slice(31,this.builderCount);
									bd.push(b1,b2,b3,b4);
								}
							}else {
								bd.push(this.builderDefinitionArray);
							}
							if (this.merchantCount > 10) {
								this.merchantDefinition = this.merchantDefinition + '</p>';
								if (this.merchantCount > 10 && this.merchantCount < 21) {
									let b1 = this.merchantDefinitionArray.slice(0,10);
									let b2 = this.merchantDefinitionArray.slice(11,this.merchantCount);
									md.push(b1,b2);
								}else if (this.merchantCount > 20 && this.merchantCount < 31) {
									let b1 = this.merchantDefinitionArray.slice(0,10);
									let b2 = this.merchantDefinitionArray.slice(11,20);
									let b3 = this.merchantDefinitionArray.slice(20,this.merchantCount);
									md.push(b1,b2,b3);
								}else {
									let b1 = this.merchantDefinitionArray.slice(0,10);
									let b2 = this.merchantDefinitionArray.slice(11,20);
									let b3 = this.merchantDefinitionArray.slice(21,30);
									let b4 = this.merchantDefinitionArray.slice(31,this.merchantCount);
									md.push(b1,b2,b3,b4);
								}
							}else {
								md.push(this.merchantDefinitionArray);
							}

							if (this.innovatorCount > 10) {
								this.innovatorDefinition = this.innovatorDefinition + '</p>';

								if (this.innovatorCount > 10 && this.innovatorCount < 21) {
									let b1 = this.innovatorDefinitionArray.slice(0,10);
									let b2 = this.innovatorDefinitionArray.slice(11,this.innovatorCount);
									ida.push(b1,b2);
								}else if (this.innovatorCount > 20 && this.innovatorCount < 31) {
									let b1 = this.innovatorDefinitionArray.slice(0,10);
									let b2 = this.innovatorDefinitionArray.slice(11,20);
									let b3 = this.innovatorDefinitionArray.slice(20,this.innovatorCount);
									ida.push(b1,b2,b3);
								}else {
									let b1 = this.innovatorDefinitionArray.slice(0,10);
									let b2 = this.innovatorDefinitionArray.slice(11,20);
									let b3 = this.innovatorDefinitionArray.slice(21,30);
									let b4 = this.innovatorDefinitionArray.slice(31,this.innovatorCount);
									ida.push(b1,b2,b3,b4);
								}
							}else {
								ida.push(this.innovatorDefinitionArray);
							}

							if (this.bankerCount > 10) {
								this.bankerDefinition = this.bankerDefinition + '</p>';

								if (this.bankerCount > 10 && this.bankerCount < 21) {
									let b1 = this.bankerDefinitionArray.slice(0,10);
									let b2 = this.bankerDefinitionArray.slice(11,this.bankerCount);
									bda.push(b1,b2);
								}else if (this.bankerCount > 20 && this.bankerCount < 31) {
									let b1 = this.bankerDefinitionArray.slice(0,10);
									let b2 = this.bankerDefinitionArray.slice(11,20);
									let b3 = this.bankerDefinitionArray.slice(20,this.bankerCount);
									bda.push(b1,b2,b3);
								}else {
									let b1 = this.bankerDefinitionArray.slice(0,10);
									let b2 = this.bankerDefinitionArray.slice(11,20);
									let b3 = this.bankerDefinitionArray.slice(21,30);
									let b4 = this.bankerDefinitionArray.slice(31,this.bankerCount);
									bda.push(b1,b2,b3,b4);
								}
							}else {
								bda.push(this.bankerDefinitionArray);
							}
							
							this.resultArray.push(
								{
									key:'Builder',
									value:this.builderCount,
									def:this.builderDefinition,
									defArray:bd
								},
								{
									key:'Merchant',
									value:this.merchantCount,
									def:this.merchantDefinition,
									defArray:md
								},
								{
									key:'Innovator',
									value:this.innovatorCount,
									def:this.innovatorDefinition,
									defArray:ida
								},
								{
									key:'Banker',
									value:this.bankerCount,
									def:this.bankerDefinition,
									defArray:bda
								}
							);
							// this.sortedResultArray = this.resultArray;
							Object.assign(this.sortedResultArray, this.resultArray);
							this.sortedResultArray.sort((a1, a2) => a2.value - a1.value);
							//eslint-disable-next-line
							console.log(this.sortedResultArray);
							this.LastAssPageLoader=true;
							this.pdfCDate = moment(new Date()).format('MMMM DD, YYYY');
							this.processingLastSpanOpp = false;
							this.processingLastSpan = true;
							this.activeStep++;
							await this.recordCCIMap();
							await this.assessmentPDFProcess();
							await this.sendEmail(); //SEND AUTO MAIL BY LAST STEP
							if(this.authUser && Object.keys(this.authUser).length) {
							await this.sendEmailAfterAssessmentForm();
							}
							this.LastAssPageLoader=false;
							this.activeStep--;
							// this.scrollToElement({behavior: 'smooth'});
							// window.location.hash = '#resultDiv';
						}
					}
				}
				
                
				// else if (this.activeStep == 6) {
				// 	this.activeStep++;
				// }
				
				if(this.activeStep == 1 && this.$route.params.userabbr == 'insight') {
					this.activeStep = 3;
				} else {
					this.activeStep++;
				}

			},
			async recordCCIMap() {
				let prospDocId = '';
				if (this.prospData.length) {
					prospDocId = this.prospData[0].id;
				} else {
					await this.getProspectDetailsByPhoneNumber(this.convertedNo);
					prospDocId = this.prospData[0].id;
				}
				let tagsArray = ['CCI'];
				if (this.prospData[0].hasOwnProperty('Tags') && this.prospData[0].Tags.length) {
					tagsArray = this.prospData[0].Tags;
					if (tagsArray.indexOf('CCI') < 0) {
						tagsArray.push('CCI');
					}
				}
				/*
				let firstNote = {};
				if(this.prospData[0].hasOwnProperty('Notes') && this.prospData[0].Notes) {
					firstNote = this.prospData[0].Notes;
					this.$set(firstNote, Date.now(), 'Prospect completed the assessment');
				} else {
				firstNote[Date.now()] = 'Prospect completed the assessment';
				}
				*/

				var notesArray1 = [];
				if(this.prospData[0].hasOwnProperty('Notes') && this.prospData[0].Notes != null || this.prospData[0].Notes != undefined) {
					notesArray1 = this.prospData[0].Notes;
				}
				let notesArray2 = [{
					'date': Date.now(),
					'description': 'Prospect completed the assessment',
					'mediaURL': ''
				}];
				let notesFinalArray = [...notesArray1, ...notesArray2];

				let ff = {
					pid:this.userDocId,
					cid:prospDocId,
					Tags:tagsArray,
					Notes:notesFinalArray,
					cciMap:{
						DateSubmitted:Date.now(),
						Builder:this.builderCount,
						Merchant:this.merchantCount,
						Innovator:this.innovatorCount,
						Banker:this.bankerCount,
						Intuitive:this.builderCount+this.merchantCount,
						Cognitive:this.innovatorCount+this.bankerCount,
						Practical:this.builderCount+this.bankerCount,
						Creative:this.merchantCount+this.innovatorCount,
						Independent:this.builderCount+this.innovatorCount,
						Community:this.bankerCount+this.merchantCount,
						SnapshotName:this.sortedResultArray[0].key+'/'+this.sortedResultArray[1].key,
						//Licensed: this.licensed,
						//EnrolledCourse: this.prelicensed
					}
				}
				let pdata  = this.calculatePriority(ff.cciMap);
				ff.cciMap['Priority'] = pdata.val;
				ff.cciMap['ProfileName'] = pdata.pf;
				ff.cciMap['ProfileId'] = pdata.pfid;
				this.TempFFData.push(ff);
				
				this.updateProspFromAssessmentFn(ff);
				// await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/updateProspFromAssessment", ff)
				// .then(response => {
				// 	//eslint-disable-next-line
				// 	console.log(response)
				// }).catch(err => {alert(`Failure in Updating prospect from assessment: ${err}`); return;});
			},
			calculatePriorityold(data) {
				let val = 0;
				let pf,pfid;
				if (this.userDocData.hasOwnProperty('CciProfiles') && this.userDocData.CciProfiles) {
					let defaultProfile =  this.userDocData.CciProfiles.find(cp => cp.Default == true);
					if (defaultProfile) {
						if (
							(data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Builder <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Builder <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Builder <= defaultProfile.BankerUpper) &&
							(data.Intuitive >= defaultProfile.IntuitiveLower && data.Builder <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Builder <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Builder <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Builder <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Builder <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Builder <= defaultProfile.CommunityUpper) 
						) {
							val = 1;
						} else if (
							((data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Builder <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Builder <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Builder <= defaultProfile.BankerUpper) )||
							((data.Intuitive >= defaultProfile.IntuitiveLower && data.Builder <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Builder <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Builder <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Builder <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Builder <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Builder <= defaultProfile.CommunityUpper))
						) {
							val = 2;
						}else if (
							((data.Builder <= defaultProfile.BuilderLower || data.Builder >= defaultProfile.BuilderUpper) ||
							(data.Merchant <= defaultProfile.MerchantLower || data.Builder >= defaultProfile.MerchantUpper) ||
							(data.Innovator <= defaultProfile.InnovatorLower || data.Builder >= defaultProfile.InnovatorUpper) || 
							(data.Banker <= defaultProfile.BankerLower || data.Builder >= defaultProfile.BankerUpper) ) &&
							((data.Intuitive <= defaultProfile.IntuitiveLower || data.Builder >= defaultProfile.IntuitiveUpper) ||
							(data.Cognitive <= defaultProfile.CognitiveLower || data.Builder >= defaultProfile.CognitiveUpper) ||
							(data.Practical <= defaultProfile.PracticalLower || data.Builder >= defaultProfile.PracticalUpper) ||
							(data.Creative <= defaultProfile.CreativeLower || data.Builder >= defaultProfile.CreativeUpper) ||
							(data.Independent <= defaultProfile.IndependentLower || data.Builder >= defaultProfile.IndependentUpper) || 
							(data.Community <= defaultProfile.CommunityLower || data.Builder <= defaultProfile.CommunityUpper))
						) {
							val = 3;
						}
						pf = defaultProfile.Name;
						pfid = defaultProfile.ProfileId;
					}else {
						val = 0;
						pf = '';
						pfid = ''
					}
				}
				return { val, pf, pfid };
			},
			// UPDATE SOME PRIORITY CONDITIONS
			calculatePriority(data) {
				let val = 0;
				let pf,pfid;
				if (this.userDocData.hasOwnProperty('CciProfiles') && this.userDocData.CciProfiles) {
					let defaultProfile =  this.userDocData.CciProfiles.find(cp => cp.Default == true);
					this.LowHighDefaultProfile.push(defaultProfile);
					//eslint-disable-next-line
					//console.log('defaultProfile', defaultProfile);
					if (defaultProfile) {
						if (
							(data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) &&
							(data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper) 
						) {
							val = 1;
						} else if (
							((data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) )||
							((data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper))
						) {
							val = 2;
						}else if (
							((data.Builder <= defaultProfile.BuilderLower || data.Builder >= defaultProfile.BuilderUpper) ||
							(data.Merchant <= defaultProfile.MerchantLower || data.Merchant >= defaultProfile.MerchantUpper) ||
							(data.Innovator <= defaultProfile.InnovatorLower || data.Innovator >= defaultProfile.InnovatorUpper) || 
							(data.Banker <= defaultProfile.BankerLower || data.Banker >= defaultProfile.BankerUpper) ) &&
							((data.Intuitive <= defaultProfile.IntuitiveLower || data.Intuitive >= defaultProfile.IntuitiveUpper) ||
							(data.Cognitive <= defaultProfile.CognitiveLower || data.Cognitive >= defaultProfile.CognitiveUpper) ||
							(data.Practical <= defaultProfile.PracticalLower || data.Practical >= defaultProfile.PracticalUpper) ||
							(data.Creative <= defaultProfile.CreativeLower || data.Creative >= defaultProfile.CreativeUpper) ||
							(data.Independent <= defaultProfile.IndependentLower || data.Independent >= defaultProfile.IndependentUpper) || 
							(data.Community <= defaultProfile.CommunityLower || data.Community <= defaultProfile.CommunityUpper))
						) {
							val = 3;
						}
						pf = defaultProfile.Name;
						pfid = defaultProfile.ProfileId;
					}else {
						val = 0;
						pf = '';
						pfid = ''
					}
				}
				return { val, pf, pfid };
			},
			changeCheckBoxEvent(event,data,i,j,k) {
				data.isBoxSelected = event.target.checked;
				let fr = this.cciMap[i][j][k];
				let selectedBoxArray = fr.filter(a=>a.isBoxSelected);
				if(selectedBoxArray.length > 2) {
					data.isBoxSelected = false;
					event.preventDefault();
				}
			},
			async getProspectDetailsByPhoneNumber(PhoneNumber) {
				const searchUser = {
					pid: this.userDocId,
					searchBy:'Number',
					searchValue:PhoneNumber,
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getProspects", searchUser)
				.then(response => {
					this.prospData = response.data;
				}).catch(err => alert(`Failure getting existing prospect match: ${err}`));
			},
			async getProspectDetailsByEmail(email) {
				const searchUser = {
					pid: this.userDocId,
					searchBy:'Email',
					searchValue:email,
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getProspects", searchUser)
				.then(response => {
					this.emailProspData = response.data;
				}).catch(err => alert(`Failure getting existing prospect match: ${err}`));
			},
			resetPageData() {
				let currentIndex = this.activeStep - 3;
				for (let j = 0;j<this.cciMap[currentIndex].length;j++) {
					for (let k = 0; k<this.cciMap[currentIndex][j].length; k++) {
						this.cciMap[currentIndex][j][k].map(a=>{a.isBoxSelected = false});
						let validateArray = this.cciMap[currentIndex][j][k].filter(a=>a.isBoxSelected);
						if (validateArray.length != 2) {
							alert('Please select two words in each box');
							return;
						}
						break;
					}
				}
			},
			// get user details from abbr value from URL
			getUserDetails() {
				const searchUser = {
					searchBy:'Abbr',
					searchValue:this.$route.params.userabbr,
				};
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getUser", searchUser)
				.then(response => {
					this.userDocData = response.data[0];
					this.userDocId = response.data[0].id;
					this.ProfileImageUrl =  this.userDocData.img ? this.userDocData.img : '';
					this.HexCode = 	this.userDocData.Hex ? this.userDocData.Hex : '';
				}).catch(err => alert(`Failure getting user match: ${err}`));
			},
			// scrollToElement(options) {
			// 	const el = this.$el.getElementsByClassName('test');
				
			// 	if (el) {
			// 		el.scrollIntoView(options);
			// 	}
			// },
		},
		data() {
			return {
				authUser:{},
				LastAssPageLoader:false,
				processingLastSpanOpp:true,
				processingLastSpan: false,
				sendMailAddress:'',
				builderCount:0,
				merchantCount:0,
				innovatorCount:0,
				bankerCount:0,
				builderDefinitionArray:[],
				builderDefinition:'',
				merchantDefinitionArray:[],
				merchantDefinition:'',
				innovatorDefinitionArray:[],
				innovatorDefinition:'',
				bankerDefinitionArray:[],
				bankerDefinition:'',
				sortedResultArray:[],
				resultArray:[],
				selectedWordsArray: [],
				isValid:false,
				prelicensedOption: false,
				prospData:{},
				emailProspData:{},
				convertedNo:'',
				HexCode:'',
				userDocData:{},
				userDocId:'',
				activeStep:1,
				form : {
					First:'',
					Last:'',
					ZipCode:'',
					Number:'',
					Email:'',
					licensed:'',
					prelicensed: '',
					// Source:'CCI',
					// Status:'New',
					// Notes:{},
					// Tags:['CCI'],
				},
				isDefault:false,
				ProfileImageUrl:'',
				cciMap:[
					[
						[
							[
								{'ID':1,'CVI_Word_ID':111,'CVI_Word':'ACTION','CVI_Word_Score':'A','CVI_Word_Definition':'Accomplishing tasks now is a primary drive for you.','isBoxSelected':false,'CVI_Word_Tooltip':"Something done that causes a physical change in location, form, or use."},
								{'ID':2,'CVI_Word_ID':112,'CVI_Word':'VISION','CVI_Word_Score':'B','CVI_Word_Definition':'You like to have a good sense of connection between what you are doing today and what you see in your future.','isBoxSelected':false,'CVI_Word_Tooltip':"To see what can happen, what can be created. A picture of what will exist in the future."},
								{'ID':3,'CVI_Word_ID':113,'CVI_Word':'STRATEGY','CVI_Word_Score':'C','CVI_Word_Definition':'Strategic thinking is your forte.','isBoxSelected':false,'CVI_Word_Tooltip':"A plan of action. The way I am choosing to go after what I want."},
								{'ID':4,'CVI_Word_ID':114,'CVI_Word':'PLANNING','CVI_Word_Score':'D','CVI_Word_Definition':'You like to follow a prescribed course, especially when you are involved with setting the course.','isBoxSelected':false,'CVI_Word_Tooltip':"Deciding how to move forward. What should we do? How should we do it? Who should do what?"},
							],
							[
								{'ID':5,'CVI_Word_ID':121,'CVI_Word':'REALITY','CVI_Word_Score':'A','CVI_Word_Definition':'You are practical and willing to face the truth.','isBoxSelected':false,'CVI_Word_Tooltip':"The truth about what exists."},
								{'ID':6,'CVI_Word_ID':122,'CVI_Word':'BELIEF','CVI_Word_Score':'B','CVI_Word_Definition':'Absolute proof, knowledge and understanding are not required in order for you to act.','isBoxSelected':false,'CVI_Word_Tooltip':"To assume knowledge of situations and things that can't be known."},
								{'ID':7,'CVI_Word_ID':123,'CVI_Word':'VALUE','CVI_Word_Score':'C','CVI_Word_Definition':'You see and understand the relative worth of people and things.','isBoxSelected':false,'CVI_Word_Tooltip':"To see and accept the price or worth of something. To hold an idea or action as being important. To make something more important than other things."},
								{'ID':8,'CVI_Word_ID':124,'CVI_Word':'PROOF','CVI_Word_Score':'D','CVI_Word_Definition':'You like to act in accordance with specific knowledge and historic evidence.','isBoxSelected':false,'CVI_Word_Tooltip':"Evidence of truth or accuracy. That which demonstrates reality."},
							],
							[
								{'ID':9,'CVI_Word_ID':131,'CVI_Word':'SMART','CVI_Word_Score':'A','CVI_Word_Definition':'You pride yourself in knowing what to do.','isBoxSelected':false,'CVI_Word_Tooltip':"Able to think effectively. Ability to make decisions well."},
								{'ID':10,'CVI_Word_ID':132,'CVI_Word':'BRIGHT','CVI_Word_Score':'B','CVI_Word_Definition':'You enjoy being a bright light in your world.','isBoxSelected':false,'CVI_Word_Tooltip':"A quick learner. Fast at figuring things out."},
								{'ID':11,'CVI_Word_ID':133,'CVI_Word':'INGENIOUS','CVI_Word_Score':'C','CVI_Word_Definition':'People see your ingenuity and resourcefulness.','isBoxSelected':false,'CVI_Word_Tooltip':"Able to combine thoughts or things in a unique way. To be good at solving problems or inventing things."},
								{'ID':12,'CVI_Word_ID':134,'CVI_Word':'ACCURATE','CVI_Word_Score':'D','CVI_Word_Definition':'Having the right information is important to you.','isBoxSelected':false,'CVI_Word_Tooltip':"On target. Right aim. Good thinking."},
							],
							[
								{'ID':13,'CVI_Word_ID':141,'CVI_Word':'QUICK','CVI_Word_Score':'A','CVI_Word_Definition':'Whatever you do, you do without much hesitation.','isBoxSelected':false,'CVI_Word_Tooltip':"Acting immediately. Fast response. Speedy."},
								{'ID':14,'CVI_Word_ID':142,'CVI_Word':'ALERT','CVI_Word_Score':'B','CVI_Word_Definition':'You like discovering new possibilities, and you consistently watch for them.','isBoxSelected':false,'CVI_Word_Tooltip':"Eyes open, seeing everything. Very awake."},
								{'ID':15,'CVI_Word_ID':143,'CVI_Word':'PERCEPTIVE','CVI_Word_Score':'C','CVI_Word_Definition':'You pride yourself in seeing and understanding people and situations.','isBoxSelected':false,'CVI_Word_Tooltip':"To know the truth quickly. To see, hear, feel, touch, and smell accurately."},
								{'ID':16,'CVI_Word_ID':144,'CVI_Word':'RELIABLE','CVI_Word_Score':'D','CVI_Word_Definition':'You do what you say you will do.','isBoxSelected':false,'CVI_Word_Tooltip':"Always available. A steady, constant source."},
							]
						],
						[	
							[
								{'ID':17,'CVI_Word_ID':211,'CVI_Word':'RELATIONSHIPS','CVI_Word_Score':'B','CVI_Word_Definition':'Nothing feels right when the people you value are distant or are in conflict.','isBoxSelected':false,'CVI_Word_Tooltip':"A connection between people or things. A way of being together."},
								{'ID':18,'CVI_Word_ID':212,'CVI_Word':'SOLUTIONS','CVI_Word_Score':'C','CVI_Word_Definition':'Development of effective responses to situations is one of your primary contributions.','isBoxSelected':false,'CVI_Word_Tooltip':"Right answers to problems. Strategies for solving problems."},
								{'ID':19,'CVI_Word_ID':213,'CVI_Word':'STATISTICS','CVI_Word_Score':'D','CVI_Word_Definition':'Facts and data are the foundation of your conclusions.','isBoxSelected':false,'CVI_Word_Tooltip':"Numbers that show the way things are. Mathematical proof."},
								{'ID':20,'CVI_Word_ID':214,'CVI_Word':'RESULTS','CVI_Word_Score':'A','CVI_Word_Definition':'You are driven to get things done.','isBoxSelected':false,'CVI_Word_Tooltip':"The sum of actions taken. The new reality created by actions."},
							],
							[
								{'ID':21,'CVI_Word_ID':221,'CVI_Word':'EXCITEMENT','CVI_Word_Score':'B','CVI_Word_Definition':'You have a natural enthusiasm and like to be in situations that are fully engaging and energized.','isBoxSelected':false,'CVI_Word_Tooltip':"A feeling of being fully awake and ready to act. The feeling caused by new thoughts, new opportunity, and new risk."},
								{'ID':22,'CVI_Word_ID':222,'CVI_Word':'EVALUATION','CVI_Word_Score':'C','CVI_Word_Definition':'You consistently observe and measure the worth of people and things.','isBoxSelected':false,'CVI_Word_Tooltip':"To make a decision about what something is worth. To gather evidence of the worth of something."},
								{'ID':23,'CVI_Word_ID':223,'CVI_Word':'FORTIFICATION','CVI_Word_Score':'D','CVI_Word_Definition':'Building protection against possible risk comes naturally.','isBoxSelected':false,'CVI_Word_Tooltip':"A structure set up to protect what is inside. The act of setting up a protection. To create safety."},
								{'ID':24,'CVI_Word_ID':224,'CVI_Word':'URGENCY','CVI_Word_Score':'A','CVI_Word_Definition':'You act as soon as you know what to do.','isBoxSelected':false,'CVI_Word_Tooltip':"The requirement to act now. The feeling of being under pressure to respond quickly."},
							],
							[
								{'ID':25,'CVI_Word_ID':231,'CVI_Word':'INVEST','CVI_Word_Score':'B','CVI_Word_Definition':'You want to receive good rewards and appreciation for time and energy spent.','isBoxSelected':false,'CVI_Word_Tooltip':"To purchase something you believe will gain value."},
								{'ID':26,'CVI_Word_ID':232,'CVI_Word':'PIECE TOGETHER','CVI_Word_Score':'C','CVI_Word_Definition':'If different things can be brought together from different resources, you will do it.','isBoxSelected':false,'CVI_Word_Tooltip':"To make do with what you have. To make things work for now. To use the best of what you have."},
								{'ID':27,'CVI_Word_ID':233,'CVI_Word':'GARNER/SAVE','CVI_Word_Score':'D','CVI_Word_Definition':'You work diligently to gather resources together and save them.','isBoxSelected':false,'CVI_Word_Tooltip':"To gather things together and preserve them. To keep things safely gathered around you."},
								{'ID':28,'CVI_Word_ID':234,'CVI_Word':'BUY','CVI_Word_Score':'A','CVI_Word_Definition':'You like to own those things that are important to you.','isBoxSelected':false,'CVI_Word_Tooltip':"To pay a price and take possession of something. To purchase."},
							],
							[
								{'ID':29,'CVI_Word_ID':241,'CVI_Word':'OPPORTUNITY','CVI_Word_Score':'B','CVI_Word_Definition':'No potential plan, idea or possibility gets by you.','isBoxSelected':false,'CVI_Word_Tooltip':"The chance to get something you want."},
								{'ID':30,'CVI_Word_ID':242,'CVI_Word':'POSSIBILITY','CVI_Word_Score':'C','CVI_Word_Definition':'Seeing potential and opportunity is a primary talent.','isBoxSelected':false,'CVI_Word_Tooltip':"A chance or likelihood that something may happen."},
								{'ID':31,'CVI_Word_ID':243,'CVI_Word':'STABILITY','CVI_Word_Score':'D','CVI_Word_Definition':'You like steady, solid situations with limited change.','isBoxSelected':false,'CVI_Word_Tooltip':"Hard to knock over. Able to stand in one place."},
								{'ID':32,'CVI_Word_ID':244,'CVI_Word':'FOCUS','CVI_Word_Score':'A','CVI_Word_Definition':'People around you know that you are generally on task.','isBoxSelected':false,'CVI_Word_Tooltip':"To look directly at something. The ability to look steadily at one thing, to concentrate one's attention on one thing."},
							]
						],
						[
							[
								{'ID':33,'CVI_Word_ID':311,'CVI_Word':'SYNERGY','CVI_Word_Score':'C','CVI_Word_Definition':'You strive to cause people and things to function well together.','isBoxSelected':false,'CVI_Word_Tooltip':"Things working well together. People or things that make each other better."},
								{'ID':34,'CVI_Word_ID':312,'CVI_Word':'UNIFORMITY','CVI_Word_Score':'D','CVI_Word_Definition':'Life is easier when people and things are reasonably similar.','isBoxSelected':false,'CVI_Word_Tooltip':"Everything is much the same. Everyone acts or looks alike."},
								{'ID':35,'CVI_Word_ID':313,'CVI_Word':'AUTONOMY','CVI_Word_Score':'A','CVI_Word_Definition':'You work best when you have plenty of room to decide and act.','isBoxSelected':false,'CVI_Word_Tooltip':"To exist and act without help or influence."},
								{'ID':36,'CVI_Word_ID':314,'CVI_Word':'TEAM WORK','CVI_Word_Score':'B','CVI_Word_Definition':'A core strategy for you is to work effectively with others.','isBoxSelected':false,'CVI_Word_Tooltip':"People working effectively together."},
							],
							[
								{'ID':37,'CVI_Word_ID':321,'CVI_Word':'BALANCE','CVI_Word_Score':'C','CVI_Word_Definition':'You like to maintain a good mix of people, activities and things in your life.','isBoxSelected':false,'CVI_Word_Tooltip':"Having the right amount of the right things. To include all the right things."},
								{'ID':38,'CVI_Word_ID':322,'CVI_Word':'INTEGRITY','CVI_Word_Score':'D','CVI_Word_Definition':'The reliability of your words and actions is critical to your sense of self respect.','isBoxSelected':false,'CVI_Word_Tooltip':"Saying what you mean. Doing what you say you will do. Being what you present yourself to be."},
								{'ID':39,'CVI_Word_ID':323,'CVI_Word':'INDEPENDENCE','CVI_Word_Score':'A','CVI_Word_Definition':'It is important for you to be self-sufficient, without boundaries.','isBoxSelected':false,'CVI_Word_Tooltip':"Freedom from the need for help or influence."},
								{'ID':40,'CVI_Word_ID':324,'CVI_Word':'FRIENDSHIP','CVI_Word_Score':'B','CVI_Word_Definition':'Being acknowledged as a friend is important to you.','isBoxSelected':false,'CVI_Word_Tooltip':"When two or more people like each other and spend time together."},
							],
							[
								{'ID':41,'CVI_Word_ID':331,'CVI_Word':'PATIENCE','CVI_Word_Score':'C','CVI_Word_Definition':'Your willingness to see things through and wait things out is a primary asset.','isBoxSelected':false,'CVI_Word_Tooltip':"The willingness to wait longer for what you want."},
								{'ID':42,'CVI_Word_ID':332,'CVI_Word':'ORDER','CVI_Word_Score':'D','CVI_Word_Definition':'Chaos is your enemy.','isBoxSelected':false,'CVI_Word_Tooltip':"Everything and everyone is in its right place and behaving as expected."},
								{'ID':43,'CVI_Word_ID':333,'CVI_Word':'DRIVE','CVI_Word_Score':'A','CVI_Word_Definition':'You are strongly self-motivated.','isBoxSelected':false,'CVI_Word_Tooltip':"The desire to make things happen."},
								{'ID':44,'CVI_Word_ID':334,'CVI_Word':'ENTHUSIASM','CVI_Word_Score':'B','CVI_Word_Definition':'You like to work and others enjoy working with you.','isBoxSelected':false,'CVI_Word_Tooltip':"The feeling of enjoyment and excitement about things that are happening."},
							],
							[
								{'ID':45,'CVI_Word_ID':341,'CVI_Word':'ILLUSTRATE','CVI_Word_Score':'C','CVI_Word_Definition':'You like to communicate with visuals and descriptions.','isBoxSelected':false,'CVI_Word_Tooltip':"To make a picture to convey an idea. To cause others to understand through careful description and the use of examples."},
								{'ID':46,'CVI_Word_ID':342,'CVI_Word':'EXPECT','CVI_Word_Score':'D','CVI_Word_Definition':'People and situations should measure up to commitments.','isBoxSelected':false,'CVI_Word_Tooltip':"To assume that what I think will happen, will actually happen."},
								{'ID':47,'CVI_Word_ID':343,'CVI_Word':'COMMAND','CVI_Word_Score':'A','CVI_Word_Definition':'Giving directives comes naturally to you.','isBoxSelected':false,'CVI_Word_Tooltip':"Tell someone to do something with authority, expecting them to do it."},
								{'ID':48,'CVI_Word_ID':344,'CVI_Word':'TEACH','CVI_Word_Score':'B','CVI_Word_Definition':'Share your knowledge and information with others; You enjoy it and others appreciate it.','isBoxSelected':false,'CVI_Word_Tooltip':"Guide another person in the process of learning."},
							]
						],
					],
					[
						[
							[
								{'ID':49,'CVI_Word_ID':411,'CVI_Word':'ORGANIZATION','CVI_Word_Score':'D','CVI_Word_Definition':'When things get messy, you may get testy.','isBoxSelected':false,'CVI_Word_Tooltip':"All the right things, all the right people are in their right places. Everyone knows what to expect from everyone else."},
								{'ID':50,'CVI_Word_ID':412,'CVI_Word':'CONCRETE','CVI_Word_Score':'A','CVI_Word_Definition':'You like to work with things that are real and tangible.','isBoxSelected':false,'CVI_Word_Tooltip':"Solid and based on facts. Connected to physical reality."},
								{'ID':51,'CVI_Word_ID':413,'CVI_Word':'ABSTRACT','CVI_Word_Score':'B','CVI_Word_Definition':'You are at home with intangibles and creative ideas.','isBoxSelected':false,'CVI_Word_Tooltip':"Ideas and theories about things but not based upon hard proof."},
								{'ID':52,'CVI_Word_ID':414,'CVI_Word':'DESIGN','CVI_Word_Score':'C','CVI_Word_Definition':'To invent new systems, processes and things is pure pleasure.','isBoxSelected':false,'CVI_Word_Tooltip':"To create the right solution for a problem. To create a system with specific benefits."},
							],
							[
								{'ID':53,'CVI_Word_ID':421,'CVI_Word':'INFORMATION','CVI_Word_Score':'D','CVI_Word_Definition':'You surround yourself with facts, figures and data.','isBoxSelected':false,'CVI_Word_Tooltip':"Recorded facts and figures regarding real things."},
								{'ID':54,'CVI_Word_ID':422,'CVI_Word':'POWER','CVI_Word_Score':'A','CVI_Word_Definition':'Your deep desire is to exert personal energy to make a positive difference.','isBoxSelected':false,'CVI_Word_Tooltip':"The ability to cause change. Personal energy applied to create a desired result."},
								{'ID':55,'CVI_Word_ID':423,'CVI_Word':'MOTIVATION','CVI_Word_Score':'B','CVI_Word_Definition':'You are good at getting others to work for and with you.','isBoxSelected':false,'CVI_Word_Tooltip':"Giving others the desire and will to act as you would like them to act."},
								{'ID':56,'CVI_Word_ID':424,'CVI_Word':'SYSTEMS','CVI_Word_Score':'C','CVI_Word_Definition':'You enjoy helping people and things work well and consistently together.','isBoxSelected':false,'CVI_Word_Tooltip':"People or things working together to create a desired benefit."},
							],
							[
								{'ID':57,'CVI_Word_ID':431,'CVI_Word':'RESOLVE','CVI_Word_Score':'D','CVI_Word_Definition':"Once started, you don't give up easily.",'isBoxSelected':false,'CVI_Word_Tooltip':"To be committed to a certain action."},
								{'ID':58,'CVI_Word_ID':432,'CVI_Word':'EFFORT','CVI_Word_Score':'A','CVI_Word_Definition':'You pride yourself in the energy you expend on projects.','isBoxSelected':false,'CVI_Word_Tooltip':"The amount of work and energy invested."},
								{'ID':59,'CVI_Word_ID':433,'CVI_Word':'AGREEMENT','CVI_Word_Score':'B','CVI_Word_Definition':'Getting what you want from others is a gentle negotiation and a friendly arrangement.','isBoxSelected':false,'CVI_Word_Tooltip':"I think and believe the way you think and believe regarding a certain issue."},
								{'ID':60,'CVI_Word_ID':434,'CVI_Word':'TENACITY','CVI_Word_Score':'C','CVI_Word_Definition':'You never quit.','isBoxSelected':false,'CVI_Word_Tooltip':"The will to continue. The commitment to keep trying."},
							],
							[

								{'ID':61,'CVI_Word_ID':441,'CVI_Word':'ADVISE','CVI_Word_Score':'D','CVI_Word_Definition':"You enjoy being the source of information and proven methodology.",'isBoxSelected':false,'CVI_Word_Tooltip':"To give suggestions and ideas. To give counsel."},
								{'ID':62,'CVI_Word_ID':442,'CVI_Word':'CANDOR','CVI_Word_Score':'A','CVI_Word_Definition':'You value straight talk and frank discussion.','isBoxSelected':false,'CVI_Word_Tooltip':"Words spoken without apology. Truth told simply without hesitation."},
								{'ID':63,'CVI_Word_ID':443,'CVI_Word':'DIPLOMACY','CVI_Word_Score':'B','CVI_Word_Definition':'Choosing your words carefully works well for you.','isBoxSelected':false,'CVI_Word_Tooltip':"To tell the truth as kindly as possible."},
								{'ID':64,'CVI_Word_ID':444,'CVI_Word':'PROCESS','CVI_Word_Score':'C','CVI_Word_Definition':'People look to you for the creation and improvement of work flow and procedures.','isBoxSelected':false,'CVI_Word_Tooltip':"The steps required to obtain a certain result."},
							]
						],
						[
							[
								{'ID':65,'CVI_Word_ID':511,'CVI_Word':'AUTHORITY','CVI_Word_Score':'A','CVI_Word_Definition':"Things go best for you when you have responsibility for results.",'isBoxSelected':false,'CVI_Word_Tooltip':"The one who knows the truth and will decide what everyone should do."},
								{'ID':66,'CVI_Word_ID':512,'CVI_Word':'HISTORY','CVI_Word_Score':'D','CVI_Word_Definition':'Knowing the past provides evidence for the future.','isBoxSelected':false,'CVI_Word_Tooltip':"The story and facts about what happened before this moment."},
								{'ID':67,'CVI_Word_ID':513,'CVI_Word':'UNITY','CVI_Word_Score':'B','CVI_Word_Definition':'Feeling a sense of togetherness with people gives you confidence.','isBoxSelected':false,'CVI_Word_Tooltip':"Everyone acting as if they were one person."},
								{'ID':68,'CVI_Word_ID':514,'CVI_Word':'CLEVERNESS','CVI_Word_Score':'C','CVI_Word_Definition':'You have wit and creativity in your thinking.','isBoxSelected':false,'CVI_Word_Tooltip':"Able to think through a wide variety of situations. Able to make right plans."},
							],
							[
								{'ID':69,'CVI_Word_ID':521,'CVI_Word':'INITIATE','CVI_Word_Score':'A','CVI_Word_Definition':"Starting new projects and ventures makes you happy.",'isBoxSelected':false,'CVI_Word_Tooltip':"To be the first to start something. To put process into motion."},
								{'ID':70,'CVI_Word_ID':522,'CVI_Word':'DOCUMENT','CVI_Word_Score':'D','CVI_Word_Definition':'Creation without effective written plans and process description is senseless.','isBoxSelected':false,'CVI_Word_Tooltip':"To record the facts about a situation, place or thing for future reference."},
								{'ID':71,'CVI_Word_ID':523,'CVI_Word':'PRESENT','CVI_Word_Score':'B','CVI_Word_Definition':'Making presentations puts zest in your life.','isBoxSelected':false,'CVI_Word_Tooltip':"The act of telling and showing others certain information."},
								{'ID':72,'CVI_Word_ID':524,'CVI_Word':'CONFIGURE','CVI_Word_Score':'C','CVI_Word_Definition':'You can always see another way to put things together.','isBoxSelected':false,'CVI_Word_Tooltip':"To arrange things within a system or space for better results."},
							],
							[
								{'ID':73,'CVI_Word_ID':531,'CVI_Word':'ACTIVATE','CVI_Word_Score':'A','CVI_Word_Definition':"You like to set things in motion.",'isBoxSelected':false,'CVI_Word_Tooltip':"To turn something on. To bring some plan or system to life."},
								{'ID':74,'CVI_Word_ID':532,'CVI_Word':'CONSOLIDATE','CVI_Word_Score':'D','CVI_Word_Definition':'You like to conserve resources and gain control by reducing the number of influences and authorities in any situation.','isBoxSelected':false,'CVI_Word_Tooltip':"To save space or time by bringing things together."},
								{'ID':75,'CVI_Word_ID':533,'CVI_Word':'STIMULATE','CVI_Word_Score':'B','CVI_Word_Definition':'You like a new charge in your life and you like to be the charge in the lives of others.','isBoxSelected':false,'CVI_Word_Tooltip':"To excite activity in other persons or things. To charge with life."},
								{'ID':76,'CVI_Word_ID':534,'CVI_Word':'REARRANGE','CVI_Word_Score':'C','CVI_Word_Definition':'If an obstacle is in your way, you move it to suit your objectives.','isBoxSelected':false,'CVI_Word_Tooltip':"To change the location of people or things. To shift things around."},
							],
							[
								{'ID':77,'CVI_Word_ID':541,'CVI_Word':'DECISIONS','CVI_Word_Score':'A','CVI_Word_Definition':"You make up your mind quickly and intuitively.",'isBoxSelected':false,'CVI_Word_Tooltip':"Choices make after learning possibilities. Setting one's mind on a certain action."},
								{'ID':78,'CVI_Word_ID':542,'CVI_Word':'REPORT','CVI_Word_Score':'D','CVI_Word_Definition':'You believe in measurement and in the presentation of measurement and data as an effective leadership tool.','isBoxSelected':false,'CVI_Word_Tooltip':"To tell what happened."},
								{'ID':79,'CVI_Word_ID':543,'CVI_Word':'OPENNESS','CVI_Word_Score':'B','CVI_Word_Definition':'You like to trust people and to share yourself with them freely.','isBoxSelected':false,'CVI_Word_Tooltip':"The willingness to listen and learn new truth or to build a new relationship."},
								{'ID':80,'CVI_Word_ID':544,'CVI_Word':'OBSERVATION','CVI_Word_Score':'C','CVI_Word_Definition':'It is important for you to watch, look and listen before you act.','isBoxSelected':false,'CVI_Word_Tooltip':"To see completely. To watch and study. To notice what is going on yet not be involved."},
							]
						],
						[
							[
								{'ID':81,'CVI_Word_ID':611,'CVI_Word':'DIVERSITY','CVI_Word_Score':'B','CVI_Word_Definition':"You enjoy lots of different people and activities.",'isBoxSelected':false,'CVI_Word_Tooltip':"Lots of different people or things included and given importance."},
								{'ID':82,'CVI_Word_ID':612,'CVI_Word':'DETAIL','CVI_Word_Score':'D','CVI_Word_Definition':'Having all of the information is important to you, even the small things.','isBoxSelected':false,'CVI_Word_Tooltip':"Lots of specific information down to small points."},
								{'ID':83,'CVI_Word_ID':613,'CVI_Word':'COMPLEXITY','CVI_Word_Score':'C','CVI_Word_Definition':'Complicated situations and problems are not a threat to you.','isBoxSelected':false,'CVI_Word_Tooltip':"A large number of related things. Lots of things to think about before you decide."},
								{'ID':84,'CVI_Word_ID':614,'CVI_Word':'SIMPLICITY','CVI_Word_Score':'A','CVI_Word_Definition':'If you can, you deal with things one at a time.','isBoxSelected':false,'CVI_Word_Tooltip':"Just a few things to think about before you decide. The most important things are easily seen."},
							],
							[

								{'ID':85,'CVI_Word_ID':621,'CVI_Word':'CHARISMA','CVI_Word_Score':'B','CVI_Word_Definition':"Charm and enthusiasm are part of your arsenal for success.",'isBoxSelected':false,'CVI_Word_Tooltip':"A quality of leadership that inspires others to follow and attracts loyalty."},
								{'ID':86,'CVI_Word_ID':622,'CVI_Word':'CONSERVATION','CVI_Word_Score':'D','CVI_Word_Definition':'You dislike any waste of resources.','isBoxSelected':false,'CVI_Word_Tooltip':"To protect and preserve resources. Keeping things safe and avoiding waste."},
								{'ID':87,'CVI_Word_ID':623,'CVI_Word':'PROBLEM-SOLVING','CVI_Word_Score':'C','CVI_Word_Definition':'Finding the best solution is one of your primary contributions.','isBoxSelected':false,'CVI_Word_Tooltip':"Gathering information about difficult or undesirable situations to find the best response."},
								{'ID':88,'CVI_Word_ID':624,'CVI_Word':'SUBSTANCE','CVI_Word_Score':'A','CVI_Word_Definition':'You only work on things or projects that have real value.','isBoxSelected':false,'CVI_Word_Tooltip':"Having basic quality and usability. That which supports existence."},
							],
							[

								{'ID':89,'CVI_Word_ID':631,'CVI_Word':'CASUAL','CVI_Word_Score':'B','CVI_Word_Definition':"Too much formality is boring and restrictive.",'isBoxSelected':false,'CVI_Word_Tooltip':"The feeling of living without tight schedules and with informal clothing and attitude."},
								{'ID':90,'CVI_Word_ID':632,'CVI_Word':'FORMAL','CVI_Word_Score':'D','CVI_Word_Definition':'Social structure and appropriate mannerisms are good for the soul.','isBoxSelected':false,'CVI_Word_Tooltip':"Within the highest accepted standards of dress, speech and action."},
								{'ID':91,'CVI_Word_ID':633,'CVI_Word':'ECLECTIC','CVI_Word_Score':'C','CVI_Word_Definition':'Your tastes are varied and diverse.','isBoxSelected':false,'CVI_Word_Tooltip':"Including many varied and unrelated things. Liking a lot of different things."},
								{'ID':92,'CVI_Word_ID':634,'CVI_Word':'PRACTICAL','CVI_Word_Score':'A','CVI_Word_Definition':'You want the things you do to make a tangible difference.','isBoxSelected':false,'CVI_Word_Tooltip':"Usable in everyday life. A person who acts reasonably, using the things at hand."},
							],
							[
								{'ID':93,'CVI_Word_ID':641,'CVI_Word':'CHANGE','CVI_Word_Score':'B','CVI_Word_Definition':"You thrive on new opportunities, especially if you participate in creating the change process.",'isBoxSelected':false,'CVI_Word_Tooltip':"To cause things to be different."},
								{'ID':94,'CVI_Word_ID':642,'CVI_Word':'MAINTAIN','CVI_Word_Score':'D','CVI_Word_Definition':'You enjoy the work of keeping systems and processes running smoothly.','isBoxSelected':false,'CVI_Word_Tooltip':"To keep what you have. To keep things the same, keep doing what you have been doing."},
								{'ID':95,'CVI_Word_ID':643,'CVI_Word':'CONSIDER ALTERNATIVES','CVI_Word_Score':'C','CVI_Word_Definition':'You like to consider all the options.','isBoxSelected':false,'CVI_Word_Tooltip':"To think about different possible actions and responses."},
								{'ID':96,'CVI_Word_ID':644,'CVI_Word':'IMPLEMENT','CVI_Word_Score':'A','CVI_Word_Definition':'You like to put things and people to work.','isBoxSelected':false,'CVI_Word_Tooltip':"To put something to work. To use what you have. To start using something."},
							]
						],
					],
					[
						[
							[
								{'ID':97,'CVI_Word_ID':711,'CVI_Word':'PATHWAYS','CVI_Word_Score':'C','CVI_Word_Definition':"Exploration of new and better approaches keeps you interested.",'isBoxSelected':false,'CVI_Word_Tooltip':"Different ways to move. Possible courses you might take to a certain destination."},
								{'ID':98,'CVI_Word_ID':712,'CVI_Word':'BOTTOM LINE','CVI_Word_Score':'A','CVI_Word_Definition':'Knowing the cost and the gain for all actions is important to you.','isBoxSelected':false,'CVI_Word_Tooltip':"Profit or loss. Total cost or total reward."},
								{'ID':99,'CVI_Word_ID':713,'CVI_Word':'DIALOG','CVI_Word_Score':'B','CVI_Word_Definition':'Free and open discussion is a major element in your leadership style.','isBoxSelected':false,'CVI_Word_Tooltip':"A conversation about something. A discussion."},
								{'ID':100,'CVI_Word_ID':714,'CVI_Word':'ANALYSIS','CVI_Word_Score':'D','CVI_Word_Definition':'You like to understand the details of situations and issues.','isBoxSelected':false,'CVI_Word_Tooltip':"To take apart, evaluate and measure accurately. To learn exactly what something is."},
							],
							[
								{'ID':101,'CVI_Word_ID':721,'CVI_Word':'REMIND','CVI_Word_Score':'C','CVI_Word_Definition':"You prefer to lead people by helping them remember agreements and commitments.",'isBoxSelected':false,'CVI_Word_Tooltip':"To help others remember what they should be doing."},
								{'ID':102,'CVI_Word_ID':722,'CVI_Word':'WORK','CVI_Word_Score':'A','CVI_Word_Definition':'You like to work and you admire others who work.','isBoxSelected':false,'CVI_Word_Tooltip':"Energy applied toward creating something or making something different."},
								{'ID':103,'CVI_Word_ID':723,'CVI_Word':'PROMOTE','CVI_Word_Score':'B','CVI_Word_Definition':'Motivating others with your visions and ideas is very satisfying.','isBoxSelected':false,'CVI_Word_Tooltip':"The selling of an idea or thing. The attempt to get people to be interested in something."},
								{'ID':104,'CVI_Word_ID':724,'CVI_Word':'REQUEST','CVI_Word_Score':'D','CVI_Word_Definition':'An appropriate request from you should be all that is required.','isBoxSelected':false,'CVI_Word_Tooltip':"To ask for something politely."},
							],
							[

								{'ID':105,'CVI_Word_ID':731,'CVI_Word':'BRAINSTORMING','CVI_Word_Score':'C','CVI_Word_Definition':"Rapid and clever exchange of ideas is a personal joy and a method of work for you.",'isBoxSelected':false,'CVI_Word_Tooltip':"A group of people suggesting ideas or solutions without criticism or boundaries."},
								{'ID':106,'CVI_Word_ID':732,'CVI_Word':'CONFLICT','CVI_Word_Score':'A','CVI_Word_Definition':'Disagreements and passionate exchanges hold no fear for you.','isBoxSelected':false,'CVI_Word_Tooltip':"When two or more people disagree and insist upon different pathways or results."},
								{'ID':107,'CVI_Word_ID':733,'CVI_Word':'DISCUSSION','CVI_Word_Score':'B','CVI_Word_Definition':'Talking with others is your way to learn and to teach.','isBoxSelected':false,'CVI_Word_Tooltip':"Two or more people expressing different thoughts and opinions without conflict."},
								{'ID':108,'CVI_Word_ID':734,'CVI_Word':"DEVIL'S ADVOCATE",'CVI_Word_Score':'D','CVI_Word_Definition':'It is important to reduce possible risks by questioning decisions and plans.','isBoxSelected':false,'CVI_Word_Tooltip':"One who asks lots of difficult questions to show likely risks and dangers."},
							],
							[
								{'ID':109,'CVI_Word_ID':741,'CVI_Word':'PUZZLES','CVI_Word_Score':'C','CVI_Word_Definition':"You like difficult situations and challenging questions.",'isBoxSelected':false,'CVI_Word_Tooltip':"Objects or situations that are in a jumble and that are difficult to put back together."},
								{'ID':110,'CVI_Word_ID':742,'CVI_Word':'CONCLUSIONS','CVI_Word_Score':'A','CVI_Word_Definition':"You are not afraid to bring things to an end; When you're done, you're done.",'isBoxSelected':false,'CVI_Word_Tooltip':"The summary of a discussion. The final opinion of someone who has evaluated a situation."},
								{'ID':111,'CVI_Word_ID':743,'CVI_Word':'VARIETY','CVI_Word_Score':'B','CVI_Word_Definition':'Something new and inspiring everyday is the spice of your life.','isBoxSelected':false,'CVI_Word_Tooltip':"Lots of differences between people, places, situations and things."},
								{'ID':112,'CVI_Word_ID':744,'CVI_Word':'COMPARISON','CVI_Word_Score':'D','CVI_Word_Definition':'Effective decisions are supported by analysis of similarities and differences.','isBoxSelected':false,'CVI_Word_Tooltip':"To evaluate two or more things, noticing and measuring the similarities and differences."},
							]
						],
						[
							[
								{'ID':113,'CVI_Word_ID':811,'CVI_Word':'JUSTICE','CVI_Word_Score':'D','CVI_Word_Definition':"You care deeply when situations or the behaviors of people are unfair, or when your knowledge is used incorrectly by others.",'isBoxSelected':false,'CVI_Word_Tooltip':"The punishment fits the crime. When rewards are equal to the risks. When everyone is held to the same standard."},
								{'ID':114,'CVI_Word_ID':812,'CVI_Word':'WORTH','CVI_Word_Score':'B','CVI_Word_Definition':"Being of high value to others and seeing high value in others is a prime concern.",'isBoxSelected':false,'CVI_Word_Tooltip':"The value that something or someone has. To be of value."},
								{'ID':115,'CVI_Word_ID':813,'CVI_Word':'WISDOM','CVI_Word_Score':'C','CVI_Word_Definition':'You are able to see the ways things are, and you know what to do about it.','isBoxSelected':false,'CVI_Word_Tooltip':"To see the way things are, and to know what to do about it."},
								{'ID':116,'CVI_Word_ID':814,'CVI_Word':'SUFFICIENCY','CVI_Word_Score':'A','CVI_Word_Definition':'You generally feel that you have enough resources, energy, and drive to achieve your goals.','isBoxSelected':false,'CVI_Word_Tooltip':"Having enough of everything you truly need."},
							],
							[
								{'ID':117,'CVI_Word_ID':821,'CVI_Word':'EFFICIENT','CVI_Word_Score':'D','CVI_Word_Definition':"Zero wasted motion, zero wasted resources, zero wasted effort; This is what you strive for.",'isBoxSelected':false,'CVI_Word_Tooltip':"To work and produce without error and waste."},
								{'ID':118,'CVI_Word_ID':822,'CVI_Word':'OPTIMISTIC','CVI_Word_Score':'B','CVI_Word_Definition':"You seldom feel defeated; You see good potential in most situations.",'isBoxSelected':false,'CVI_Word_Tooltip':"To expect good things in the future."},
								{'ID':119,'CVI_Word_ID':823,'CVI_Word':'MENTAL AGILITY','CVI_Word_Score':'C','CVI_Word_Definition':'Others look to you for your quick and responsive mind.','isBoxSelected':false,'CVI_Word_Tooltip':"The ability to think creatively about many things."},
								{'ID':120,'CVI_Word_ID':824,'CVI_Word':'EFFECTIVE','CVI_Word_Score':'A','CVI_Word_Definition':'It is important for you to show good results for invested energy.','isBoxSelected':false,'CVI_Word_Tooltip':"To do things well and to get the results desired."},
							],
							[
								{'ID':121,'CVI_Word_ID':831,'CVI_Word':'INSTRUCT','CVI_Word_Score':'D','CVI_Word_Definition':"You like to provide others with proven ideas and methodology.",'isBoxSelected':false,'CVI_Word_Tooltip':"To give information. To help others to know and understand."},
								{'ID':122,'CVI_Word_ID':832,'CVI_Word':'PULL','CVI_Word_Score':'B','CVI_Word_Definition':"You like to energize and motivate others to work with you.",'isBoxSelected':false,'CVI_Word_Tooltip':"To make someone or something come your way. To draw something behind you."},
								{'ID':123,'CVI_Word_ID':833,'CVI_Word':'GUIDE','CVI_Word_Score':'C','CVI_Word_Definition':'You are seen as a valuable resource for leading people toward the right ideas and the right direction.','isBoxSelected':false,'CVI_Word_Tooltip':"To lead the way. Show others which path to take."},
								{'ID':124,'CVI_Word_ID':834,'CVI_Word':'PUSH','CVI_Word_Score':'A','CVI_Word_Definition':'People work harder and more things happen when you set the pace.','isBoxSelected':false,'CVI_Word_Tooltip':"To make someone or something move ahead of you."},
							],
							[
								{'ID':125,'CVI_Word_ID':841,'CVI_Word':'INFORM','CVI_Word_Score':'D','CVI_Word_Definition':"Your knowledge is generally available to others.",'isBoxSelected':false,'CVI_Word_Tooltip':"To give information you have to others. To let someone know what you know."},
								{'ID':126,'CVI_Word_ID':842,'CVI_Word':'INSPIRE','CVI_Word_Score':'B','CVI_Word_Definition':"You have the ability to help people feel hopeful and courageous.",'isBoxSelected':false,'CVI_Word_Tooltip':"To stir up someone's spirit. To create a picture of what can be, one that attracts the work of others."},
								{'ID':127,'CVI_Word_ID':843,'CVI_Word':'SUGGEST','CVI_Word_Score':'C','CVI_Word_Definition':'You like to lead through presentation of intelligent alternatives.','isBoxSelected':false,'CVI_Word_Tooltip':"Tell someone what you think they ought to do."},
								{'ID':128,'CVI_Word_ID':844,'CVI_Word':'DIRECT','CVI_Word_Score':'A','CVI_Word_Definition':'You like speaking clearly, telling the truth and asking for what you want.','isBoxSelected':false,'CVI_Word_Tooltip':"Tell others what you want them to do."},
							]
						],
						[
							[
								{'ID':129,'CVI_Word_ID':911,'CVI_Word':'CONFIDENT','CVI_Word_Score':'A','CVI_Word_Definition':"There are few situations in which you feel inadequate.",'isBoxSelected':false,'CVI_Word_Tooltip':"To have faith in yourself and the decisions you make."},
								{'ID':130,'CVI_Word_ID':912,'CVI_Word':'STEADY','CVI_Word_Score':'D','CVI_Word_Definition':"You are a constant force in your world.",'isBoxSelected':false,'CVI_Word_Tooltip':"Hard to knock off course. Constantly moving at the same speed."},
								{'ID':131,'CVI_Word_ID':913,'CVI_Word':'RATIONAL','CVI_Word_Score':'C','CVI_Word_Definition':'Acting foolishly or illogically is not a common experience for you.','isBoxSelected':false,'CVI_Word_Tooltip':"To think about things before taking action."},
								{'ID':132,'CVI_Word_ID':914,'CVI_Word':'COURAGEOUS','CVI_Word_Score':'B','CVI_Word_Definition':'You are willing to put yourself at risk in thought and action.','isBoxSelected':false,'CVI_Word_Tooltip':"Acting even when afraid. Doing what others consider to be dangerous or risky."},
							],
							[
								{'ID':133,'CVI_Word_ID':921,'CVI_Word':'STRENGTH','CVI_Word_Score':'A','CVI_Word_Definition':"You use your power, physical and personal, to get what you want.",'isBoxSelected':false,'CVI_Word_Tooltip':"Physical or moral power. The ability to exert energy."},
								{'ID':134,'CVI_Word_ID':922,'CVI_Word':'PRECISION','CVI_Word_Score':'D','CVI_Word_Definition':"You strive for exacting control of action and words.",'isBoxSelected':false,'CVI_Word_Tooltip':"Making things exactly as they are supposed to be. Doing things carefully, to perfection."},
								{'ID':135,'CVI_Word_ID':923,'CVI_Word':'RESOURCEFULNESS','CVI_Word_Score':'C','CVI_Word_Definition':'You use everything that is available to meet requirements.','isBoxSelected':false,'CVI_Word_Tooltip':"To know where and how to quickly find essential things."},
								{'ID':136,'CVI_Word_ID':924,'CVI_Word':'HARMONY','CVI_Word_Score':'B','CVI_Word_Definition':'Work for harmony; You want it.','isBoxSelected':false,'CVI_Word_Tooltip':"Working together in a natural and pleasant manner."},
							],
							[
								{'ID':137,'CVI_Word_ID':931,'CVI_Word':'EMOTION','CVI_Word_Score':'A','CVI_Word_Definition':"People around you know that you are emotionally based and capable of arousing emotions in others.",'isBoxSelected':false,'CVI_Word_Tooltip':"Fear, anger, sadness, excitement, joy, etc."},
								{'ID':138,'CVI_Word_ID':932,'CVI_Word':'KNOWLEDGE','CVI_Word_Score':'D','CVI_Word_Definition':"You like to be the one who knows; being right and being able to prove it is important to you.",'isBoxSelected':false,'CVI_Word_Tooltip':"Complete understanding of something. Having a complete picture of a thing."},
								{'ID':139,'CVI_Word_ID':933,'CVI_Word':'INTELLECT','CVI_Word_Score':'C','CVI_Word_Definition':'You value and rely upon your mental abilities.','isBoxSelected':false,'CVI_Word_Tooltip':"The ability to think."},
								{'ID':140,'CVI_Word_ID':934,'CVI_Word':'HEART','CVI_Word_Score':'B','CVI_Word_Definition':'Your commitment to others and to your own life is an encouragement to others.','isBoxSelected':false,'CVI_Word_Tooltip':"To feel empathy and hope for others. To keep trying when others may quit."},
							],
							[
								{'ID':141,'CVI_Word_ID':941,'CVI_Word':'RIGHTEOUSNESS','CVI_Word_Score':'A','CVI_Word_Definition':"It is important to you that you do the right thing.",'isBoxSelected':false,'CVI_Word_Tooltip':"Acting with integrity, and according to the law. The desire to be good."},
								{'ID':142,'CVI_Word_ID':942,'CVI_Word':'LAW & ORDER','CVI_Word_Score':'D','CVI_Word_Definition':"You believe people should obey the law and stay within social convention.",'isBoxSelected':false,'CVI_Word_Tooltip':"Holding people to the legal standards of society. Requiring people to obey the rules and stay in line."},
								{'ID':143,'CVI_Word_ID':943,'CVI_Word':'COMPASSION','CVI_Word_Score':'C','CVI_Word_Definition':'Understanding others and working with them is a key asset of yours.','isBoxSelected':false,'CVI_Word_Tooltip':"The ability to see and understand why others act the way they do."},
								{'ID':144,'CVI_Word_ID':944,'CVI_Word':'TRUTH','CVI_Word_Score':'B','CVI_Word_Definition':'It is important for you to see people and things as they really are.','isBoxSelected':false,'CVI_Word_Tooltip':"The way things are. Established fact."},
							]
						]
					]
				],
				TempFFData: [],
				LowHighDefaultProfile: [],
				pdfCDate: '',
				snapshotDetails:{},
			}
        },
        updated() {
			// this.checkErrorStatus();
        },
		created() {
			this.authUser = auth.currentUser;
			this.getUserDetails();
			// let element1 = document.getElementById("test");
			// element1.scrollIntoView({behavior: "smooth", block: "end"});
			
			if(Object.keys(this.$route.query).length) {
				this.form.First = (this.$route.query && this.$route.query.fn) ? this.$route.query.fn : '';
				this.form.Last = (this.$route.query && this.$route.query.ln) ? this.$route.query.ln : '';
				this.form.Number = (this.$route.query && this.$route.query.ph) ? this.$route.query.ph : '';
				this.convertedNo = this.$parseNumber(this.form.Number);	
				this.form.ZipCode = (this.$route.query && this.$route.query.zip) ? this.$route.query.zip : '';
				this.form.Email = (this.$route.query && this.$route.query.em) ? this.$route.query.em : '';
				//eslint-disable-next-line
				console.log("this.$route.query.test", this.$route.query);
			}
			
			
		}
	}
</script>

<style scoped>
.processingLastSpan{
	color: #007bff;
    border: 1px solid #007bff;
    padding: 10px;
    border-radius: 3px;
    font-size: 12px;
}
.form-group-for-checkbox input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.form-group-for-checkbox label {
  position: relative;
  cursor: pointer;padding-left: 25px;
}

.form-group-for-checkbox label:before {
	content: '';
    /* background: red; */
    -webkit-appearance: none;
    background-color: transparent;
    border: 2px solid #042b79;
    -webkit-box-shadow: 0 1px 2px rgb(0 0 0 / 5%), inset 0px -15px 10px -12px rgb(0 0 0 / 5%);
    box-shadow: 0 1px 2px rgb(0 0 0 / 5%), inset 0px -15px 10px -12px rgb(0 0 0 / 5%);
    padding: 7px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
	position: absolute;
    left: 0;
    margin-right: 5px;
}
.form-group-for-checkbox input:checked + label:before{
	background-color: #042b79
}
.form-group-for-checkbox input:checked + label:after {
    content: '';
    display: block;
    position: absolute;
    top: 3px;
    left: 6px;
    width: 6px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(
45deg);
    transform: rotate(
45deg);
}
.m-top-10{
	margin-top: -10px;
}
.checkbox-label{
	font-size:12px;
}
.red{
	color: red;
}
.contact-information-stepper {
    max-width: 940px;padding:100px 0px;
}
.contact-logo{
	min-height: 100px;
	min-width: 200px;
	max-height: 150px;
    max-width: 600px;
}
.contact-last-form .bv-no-focus-ring {
    display: flex;
    align-items: center;
}

/* for dark dynamic color border */
.border-top-before:after {
	content: '';
	position: absolute;
	left: 0;bottom: 100%;right: 0;
	/* border-bottom: 5px solid */
	
}
.border-top-before {
    position: relative;
	border-width: 3px;
	border-style: solid;
}

/* border-bottom for title */
.border-bottom-solid {
    border-bottom: 0.5px solid #000;
    padding-bottom: 10px;
}

/* all-border-box css */
.custom-box-4 .four-box {
    width: calc((100% / 4) - 2px);
    margin: 1px;
	padding: 10px 8px 13px 8px;
}
.border-all{
	border: 1px solid #000;
	border-radius: 4px;
}
.custom-box-4{
	padding: 0.7px;
}

.copyright-sc {
    opacity: 0.4;
}
.overflow-remove{
	overflow: auto;
    height: 100vh;
    /* width: 100vh; */
    max-width: 100%;
}
.contact-list-info{
	fill: #007bff !important;
    width: 9px !important;
    margin-top: -5px;
}
.contact-infor-table table th,td{
	border: 1px solid #000;
}
.contact-infor-table th, td {
    border: 1px solid #000;
    text-align: center;
}
.contact-page-bg{
	background: #fff;
}
.color-dark-grey{
	color: #726f6f !important;
}

.licensespan1{
	display: inherit;
}
.licensespan1 input{
	width: 18px;
    height: 18px;
}
.licensespan2{
	margin: 0px 10px 0px 5px;
}

.assPDFBody {
    background: #fff;
    padding: 10px 26px; 
    font-size: 18px;
}
.assPDFBody .RangeTableContent .hiringRecommendation {
    font-size: 20px;
    margin-top: 35px;
    margin-bottom: 20px;
}
.assPDFBody .pdftitle {
    color: #1e5577;
    font-weight: 700;
    font-size: 20px;
    padding: 10px 0px;
}

.assPDFBody .pdfsubtitle span {
    width: 22%;
    display: inline-block;
}
.assPDFBody .RangeTableContent th:first-child, 
.assPDFBody .RangeTableContent .typesTitle {
    font-size: 18px;
}
.assPDFBody .RangeTableContent .ratingKeySection{
    padding: 12px 0px
}
.assPDFBody .pdfsubtitle {
    margin: 15px 0px 20px 0px;
}

.assPDFBody .RangeTableContent {
    margin: 0px;
}

.assPDFBody .RangeTableContent .ratingKeySection .ratingPipe {
    padding: 0px 30px;
}
.assPDFBody .RangeTableContent .ratingKeySection .ratingKey{
    padding-right: 65px;
}
.assPDFBody .RangeTableContent .ratingKeySection .ratingDiv {
    display: flex;
    align-items: center;
}
.RangeTableContent .hiringRecommendation .righttitle {
    width: 30%;
}
.assPDFBody .RangeTableContent .ratingKeySection{
	position: relative;
	display: flex;
    margin-top: 10px;
	align-items: center;

    /* position: relative;
	display: flex;
    width: 100%;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding: 8px 0;
    margin-top: 10px;
    overflow-x: hidden; */
}
.assPDFBody .RangeTableContent .ratingKeySection .ratingTitle {
    margin-left: 40px;
}
.contact-infor-table .assPDFBody table th[data-v-cc35de26], td{
    border-left: none;
}

@media(max-width:767px){
	.custom-box-4 .four-box{
		width: calc((100% / 2) - 2px);
	}
	.four-box .form-group-for-checkbox label{
		margin: 0px !important;
	}
	.contact-logo {
        max-width: 400px;
        /* max-height: 100px; */
        /* width: 100%; */
        height: auto;
		margin-left: 20px;
        margin-right: 20px;
    }
	.CoreCapText {
        position: relative;
        font-size: 14px;
        text-align: center;
        margin-top: 10px;
    }
	.CoreCapSection {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
.assPDFSection{
	opacity: 0;
	height: 1%;
	overflow-y: scroll;
}
.assPDFSection .pdfLogo{
	background: #1e5577; 
	color: #fff; 
	padding: 10px 20px
}
.assPDFSection .pdfLogo img{
	width:24%; 
	margin: 10px 0px 5px 0px;
}
.assPDFSection .scorecardImg img{
	width: 10%;
	float: right; 
	margin-top: -40px; 
	margin-right: 8%;
}
</style>

<style>
.CoreCapSection{
	position: relative;
}
.CoreCapText{
	position: absolute;
    bottom: 2px;
    right: 2px;
    font-size: 16px;
    color: #726f6f;
    font-weight: 600;
}
</style>